// Script and logic (c) bettercom gmbh, Bernau, Germany
// $Id$
//

import Sentry from 'sentry';

global.JQ = jQuery.noConflict();
JQ(document).ready(function () {
    JQ('.scriptblocker-notice').hide();
});
global.LOGLEVEL = 99;
global.JSONURI = '/TR/json';
global.PRODSYS = document.location.host.match(/^calc\.waldenburger\./) ? true : false;
global.WALDI = document.location.host.match(/calc\.waldenburger\./) ? true : false;
global.idleTime = 0;
global.maxIdle = 10800; // 3 hours
global.mailExpr = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
global.mobiExpr = /^((\+|00)[1-9]\d{0,3}|0 ?[1-9]|\(00? ?[1-9][\d ]*\))[\d\-/ ]*$/;
// Spartenerkennung, Erkennung von Feldnamen:
// Beispiel: 'f_phth-hh_20180101_wf'
// p[0] : Gesamtstring 'f_phth-hh_20180101_wf'
// p[1] : Ggf. Feldprefix 'f_'
// p[2] : Sparte 'phth'
// p[3] : Ggf. Subsparte '-hh'
// p[4] : Ggf. Version '20180101'
// p[5] : Feldname '_wf'
global.fldExpr = /^([#a-z]{0,4}_)?([a-z\d]{4,6})(-[a-z]{2})?(_\d{4,8})?([a-z\d_]+)$/
global.today = moment().format("DD.MM.YYYY");
global.year = moment().format("YYYY");
global.tomorrow = moment().add(1, 'd').format("DD.MM.YYYY");
global.tomorrowInOneYear = moment().add(1, 'd').add(1, 'y').format("DD.MM.YYYY");
global.in2days = moment().add(2, 'd').format("DD.MM.YYYY");
global.in1year = moment().add(1, 'y').format("DD.MM.YYYY");
global.in1yearPlus1 = moment().add(1, 'y').add(1, 'd').format("DD.MM.YYYY");
global.in3year = moment().add(3, 'y').format("DD.MM.YYYY");
global.in3yearPlus1 = moment().add(3, 'y').add(1, 'd').format("DD.MM.YYYY");
global.zws = {
    '0': ['einmalig', 'Einmalig'],
    '1': ['jährlich', 'Jährlich'],
    '2': ['halbjährlich', 'Halbjährlich (+3%)'],
    '4': ['vierteljährlich', 'Vierteljährlich (+5%)'],
    '12': ['monatlich', 'Monatlich (+5%)']
};

// See https://stackoverflow.com/questions/1366127/instantiate-a-javascript-object-using-a-string-to-define-the-class-name
var stringToFunction = function (str) {
    var arr = str.split(".");
    var fn = (window || this);
    BC.debug('stringToFunction(): ', [arr, fn], 512);
    arr[0] = arr[0].toUpperCase();
    for (var i = 0, len = arr.length; i < len; i++) {
        fn = fn[arr[i]];
    }

    if (typeof fn !== "function") {
        throw new Error("function not found");
    }

    return fn;
};

global.chk_iban = function (v) {
    var parts;
    var remainer = '';
    var iban = v.toUpperCase().replace(/\W/g, '');
    //if (iban.length != 22) return false;
    iban = iban.substr(4) + iban.substr(0, 4);
    for (var i = 0; i <= 25; i++) {
        while (iban.search(String.fromCharCode(i + 65)) != -1) {
            iban = iban.replace(String.fromCharCode(i + 65), String(i + 10));
        }
    }
    parts = Math.ceil(iban.length / 7);
    for (var i = 1; i <= parts; i++) {
        remainer = String(parseFloat(remainer + iban.substr((i - 1) * 7, 7)) % 97);
    }
    return remainer;
};

JQ.datepicker.setDefaults(JQ.datepicker.regional['de']);

// http://www.1stwebdesigns.com/blog/development/multiple-select-with-checkboxes-and-jquery
/*JQ.fn.multiselect = function() {
    JQ(this).each(function() {
        var checkboxes = JQ(this).find("input:checkbox");
        checkboxes.each(function() {
            var checkbox = JQ(this);
            // Highlight pre-selected checkboxes
            if (checkbox.prop("checked"))
                checkbox.parent().addClass("multiselect-on");

            // Highlight checkboxes that the user selects
            checkbox.click(function() {
                if (checkbox.prop("checked"))
                    checkbox.parent().addClass("multiselect-on");
                else
                    checkbox.parent().removeClass("multiselect-on");
            });
        });
    });
}; */

try {
    JQ.tablesorter.addParser({
        id: "DEdate",
        is: function (s) {
            return /\d{2}\.\d{2}\.\d{4}.*/.test(s);
        },
        format: function (s) {
            s = s.replace(/(\d{2})\.(\d{2})\.(\d{4}).*/, '$3$2$1');
            return s;
        },
        type: 'numeric'
    });
    JQ.tablesorter.addParser({
        id: "DEdatetime",
        is: function (s) {
            return /\d{2}\.\d{2}\.\d{4}.*\d{2}:\d{2}.*/.test(s);
        },
        format: function (s) {
            s = s.replace(/(\d{2})\.(\d{2})\.(\d{4}).*(\d{2}):(\d{2}).*/, '$3$2$1$4$5');
            return s;
        },
        type: 'numeric'
    });
} catch (e) {
    Sentry.captureException(e);
}

jQuery.fn.center = function () {
    this.css("position", "absolute");
    this.css("top", Math.max(0, ((JQ(window).height() - JQ(this).outerHeight()) / 2) +
        JQ(window).scrollTop()) + "px");
    this.css("left", Math.max(0, ((JQ(window).width() - JQ(this).outerWidth()) / 2) +
        JQ(window).scrollLeft()) + "px");
    return this;
}

// not needed anymore <mw@201created.de>
// try {
//     Inputmask.extendAliases({
//         'inv_vs' : {
//             alias: 'currency',
//             allowMinus: false,
//             allowPlus: false,
//             greedy: true,
//             insertMode: true,
//             mask: '[9]99.999 €',
//             min: 25000,
//             numericInput: true,
//             placeholder: '_',
//             positionCaretOnTab: false,
//             radixPoint: ',',
//             rightAlign: false,
//         },
//         'tod_vs' : {
//             alias: 'currency',
//             allowMinus: false,
//             allowPlus: false,
//             greedy: true,
//             insertMode: true,
//             mask: '[9]99.999 €',
//             min: 0,
//             numericInput: true,
//             placeholder: '_',
//             positionCaretOnTab: false,
//             radixPoint: ',',
//             rightAlign: false,
//         },
//         'unr_vs' : {
//             alias: 'currency',
//             allowMinus: false,
//             allowPlus: false,
//             greedy: true,
//             insertMode: true,
//             mask: '[9][.][9][9]9 €',
//             min: 0,
//             numericInput: true,
//             placeholder: '_',
//             positionCaretOnTab: false,
//             radixPoint: ',',
//             rightAlign: false,
//         },
//         'kht_vs' : {
//             alias: 'currency',
//             allowMinus: false,
//             allowPlus: false,
//             greedy: true,
//             insertMode: true,
//             mask: '[9]9 €',
//             min: 0,
//             numericInput: true,
//             placeholder: '_',
//             positionCaretOnTab: false,
//             radixPoint: ',',
//             rightAlign: false,
//         }
//     });
// }
// catch (e) {
//     console.log('Missing Inputmask-script!');
//     Sentry.captureException(e);
// }

global.BC = {

    // Funktionen

    appendImageIcons: function () {
        JQ('.tab, .boxheader, .append-info-icon').each(function (i, e) {
            if (JQ(e).attr('title')) {
                if (!JQ(e).data('infohead')) {
                    JQ(e).attr('data-infoHead', 'Allgemeine Information')
                }
                var image = document.createElement("img");
                image.setAttribute('id', 'info-icon-' + e.innerText + '-' + i);
                image.setAttribute('class', 'infobtn');
                image.setAttribute('src', '/images/icon_info_red.svg');
                image.setAttribute('data-infoHead', JQ(e).data('infohead'));
                image.setAttribute('data-infoHtml', JQ(e).attr('title'));

                JQ(e).append(image);
                JQ(e).attr('title', '');
            }
        });
    },

    branch: function (e) {
        if (!e) {
            // GETTER
            return {
                branch: ALL.branch,
                branch2: ALL.branch2,
                branchv: ALL.branchv
            };
        }
        // SETTER
        var i = BC.get_id(e);
    },

    debug: function (t, d, l) {
        // Schreibt Text t mit Daten d in das console.log,
        // wenn Loglevel l < globalem Loglevel
        var e;
        if (l === undefined) l = 63;
        if (d === undefined) d = '---';
        if (l > LOGLEVEL) return;
        var n = moment().format('YYYY-MM-DD HH:mm:ss.SSSS');
        try {
            e = new Error().stack.split('\n');
        } catch (ex) {
            e = ['1 - No stacktrace available', '2 - No stacktrace available!'];
        }
        if (l < 17) {
            console.error(n, l, t, d);
            for (var i = 1; i < e.length - 1; i++) {
                console.error(n, l, ' => ' + BC.debug_str(e[i]));
            }
        } else if (l < 33) {
            console.warn(n, l, t, d);
            for (var i = 1; i < e.length - 1; i++) {
                console.warn(n, l, ' => ' + BC.debug_str(e[1]));
            }
        } else if (l < 65) {
            console.info(n, l, t, d);
        } else if (l < 129) {
            console.log(n, l, t, d);
        } else {
            console.debug(n, l, t, d);
        }
        if (l < 33) console.log('============================================================');
    },

    debug_str: function (s) {
        try {
            var d = s.split('@')[0] + ' @ ';
            return d + s.split('/').pop();
        } catch (e) {
            return s;
        }
    },

    get_id: function (e) {
        if (typeof (e) === 'object' && e[0] && e[0].id === 'thv-box') {
            return;
        }
        var i = '';
        try {
            if (typeof (e) == 'string' && e) {
                i = JQ(e).first().prop('id');
            } else if (typeof (e) == 'object' && e.id) {
                i = e.id;
            } else if (typeof (e) == 'object' && e[0] && e[0].id) {
                i = e[0].id;
            } else if (JQ(e).prop('id')) {
                i = JQ(e).prop('id');
            } else if (typeof (e) == 'object' && e.target) {
                i = BC.get_id(e.target);
            } else if (e.type && e.type.indexOf('unfa') === 0) {
                i = '#div_' + e.type + '_rslt'
            } else {
                BC.debug('BC.get_id() - NO ID FOUND - WHAT SHALL ID DO?', e, 16);
                return '';
            }
            if (i && i.slice(0, 1) != '#') i = '#' + i;
            return i;
        } catch (ex) {
            BC.debug('BC.get_id() failed!', ex, 16);
            Sentry.captureException(ex);
            if (e.selector) return e.selector;
            if (typeof (e) == 'string') return e;
        }
        return '';
    },

};

global.ALL = {
    notifyHeight: function () {
        BC.debug('ALL.notifyHeight(): height => ' + document.body.scrollHeight, null, 64);
        const message = {height: document.body.scrollHeight, width: ALL._width || document.body.scrollWidth + 25};
        ALL._width = message.width;
        window.top.postMessage(message, "*");
    },
    // Im adr-dict speichern wir über alle Sparten hinweg eine Risikoanschrift,
    // die bei der Änderung in einer Sparte bei allen anderen ebenfalls geändert
    // wird.
    adr: {
        plz: '00000',
        olist: '', // Für die <option>-Listen
        slist: '', // "
        hlist: '', // "
        ort: '',
        snr: 0,
        str: '',
        hnr: '',
        vn: false,  // true, wenn VN-Adresse bearbeitet wird => kein Durchreichen der Adresse
        vn_olist: '',
        vn_slist: '',
        vn_hlist: '',
        vn_ort: '',
        vn_plz: '00000',
        vn_snr: 0,
        vn_str: '',
        vn_hnr: '',
        zz: 0
    },
    branch: 'xxxx', // Haupt-Sparte, in der Berechnung stattfindet (z.B. phth)
    branch2: 'xxxx-xxx', // Sparte inkl. Subsparte (z.B. phth-hh = HuG-Haftpflicht)
    branchv: 'dddddddd', // Version, regelmässig z.B. 20180801
    branches: [],     // Sparten kommen aus priv.js bzw. gwrb.js
    data: {},     // Ggf. Daten aus dem Laden von Angeboten zur Bearbeitung
    dates_ok: false,  // true wenn Datumsfelder und Laufzeit ok
    direct: false,  // Bei Direktkundenseite true
    endisabled: {},     // Objekt mit den Feldern die en- bzw. disabled werden muessen
    Err: 0,
    FldsAll: {},     // Vorhandene Felder (via JSON)
    FldsSet: {},     // Felder mit Nicht-Null-Werten
    hints: [],     // Bereits angezeigte Texte für div_generic_hints
    mobile: false,  // true wenn neue Mobil-Seiten oder neues UI
    mustVN: [['#f_vn_nachname', 'Nachname VN'],
        ['#f_vn_gebdat', 'Geburtsdatum VN'],
        ['#f_vn_ort', 'Ort'],
        ['#f_vn_plz', 'Postleitzahl'],
        ['#f_vn_str', 'Strasse'],
        //['#f_vn_plz_ort', 'PLZ und Ort'],
        //['#f_vn_strasse', 'Strasse und Hausnummer'],
        ['#f_vn_email', 'Mail-Adresse'],
        ['#f_vn_mobnr', 'Mobilfunknummer'],
        //['#f_email1', 'Mail-Adresse für Angebot'],
        ['#f_vn_ds_1', 'Bestätigung Datenschutzerklärung']],
    PLZ: '00000',
    // Hier speichern, wenn bestimmte Listen geladen wurden, wegen synchron und so....
    set: {
        PLZ: false,
        ORT: false,
        STR: false,
        HNR: false,
        ZUERS: false,
        recalced: false
    },
    showHints: true,
    // steps fuer die Anzeigensteuerung der mobilen Seiten mit 1 - n divs
    // steps[0] = Current position (div)
    // steps[1] = Maximum allowed position (div) - depends on number of screens already filled
    // steps[2] = Maximum position (div) XXX: Do we need that?
    steps: [0, 1, 99],
    us_id: 0,
    vn_set: false,
    zzz: false,
    _width: 0,

    checkIfBikeProdYearIsCurrentYear: function () {
        return FHRD.bikes.filter(function (bike) {
            return new Date().getFullYear().toString() === JQ('#f_fhrd_yprd-' + bike.id).val();
        }).length === FHRD.bikes.length;
    },

    callback: function (data) {
        // Einfache Callback-Funktion die z.B. nach dem POSTen
        // von Antragsdaten verwendet werden kann für die Anzeige
        // der Rückmeldung vom Server
        BC.debug('ALL.callback(): data => ', data, 64);
        JQ('#div_da').dialog('close').html('');
        if (data.ERROR) {
            ALL.chkError(data);
        } else {
            ALL.showHint(data.text);
        }
    },

    chgBtrZW: function (product) {
        // Blende unterjährigen Beitrag ein bei unterjähriger
        // Zahlweise, ansonsten blende aus.
        BC.debug('ALL.chgBtrZW(): product => ', [product, ALL.branch], 64);
        var zw_txt;
        try {
            var zw = JQ('#f_' + product + '_zw').val() || JQ('#f_' + ALL.branch + '_zw').val();
            var zw_text = zws[zw][0];
            BC.debug('ALL.chgBtrZW(): ZW => ', [zw, zw_text], 64);
            JQ('#span_sum_zw').text(zw_text);
            if (zw == '1' && product.slice(0, 4) != 'unfa') {
                JQ('#div_brt1').hide();
                return;
            }
            JQ('#span_zw_text').text((zw_text + 'e'));
            JQ('#div_brt1').show()
        } catch (e) {
            BC.debug('ALL.chgBtrZW() failed!', e, 16);
            Sentry.captureException(e);
            JQ('#div_brt1').hide();
            return;
        }
    },

    chgButtons: function (b) {
        /** @var {boolean} preventDA if the DA Button may be enabled*/
        var preventDA;

        try {
            /** @var {int} isMga Whether the user is in the MGA group. Defined in the HTML using the python templating */
            preventDA = isMga == 1;
        } catch (e) {
            // isMga is not defined. Assume user is not in group MGA
            preventDA = false;
        }

        // En- or disable Buttons in list of premiums
        BC.debug('ALL.chgButtons(): Setting state to', b, 64);
        //JQ('#div_all_rslt .btn').button('option', {disabled: b});
        JQ('#div_all_rslt .ui-button').button('option', {disabled: !b});

        // THV manages the state of the an and da button itself therefor we need to set it to the current state of THV
        var thvOfferButton = JQ('#b_thv_go2datavn');
        /** @var {boolean} isThvButtonDisabled */
        var isThvButtonDisabled = !!thvOfferButton && thvOfferButton.hasClass('ui-state-disabled');
        JQ('#a_thv_an').button('option', {disabled: !b || isThvButtonDisabled});
        JQ('#a_thv_da').button('option', {disabled: !b || isThvButtonDisabled});

        if (ALL.mobile) {
            ALL.chgMobButton('#btn_fwd_4', b);
            ALL.chgMobButton('#btn_fwd_4_a', b);
        }

        if (preventDA) {
            /** @var {jQuery} daButton */
            var daButton = JQ('.btn4da');

            daButton.prop('disabled', true);
            daButton.addClass('ui-state-disabled');
            daButton.addClass('ui-button-disabled');
        }

        var phvoAnButton = JQ('#a_phvo_an');
        var phvoDaButton = JQ('#a_phvo_da');

        if (!PHVO.valid || !b) {
            phvoAnButton.prop('disabled', true);
            phvoAnButton.addClass('ui-state-disabled');
            phvoAnButton.addClass('ui-button-disabled');

            phvoDaButton.prop('disabled', true);
            phvoDaButton.addClass('ui-state-disabled');
            phvoDaButton.addClass('ui-button-disabled');
        } else {
            phvoAnButton.prop('disabled', false);
            phvoAnButton.removeClass('ui-state-disabled');
            phvoAnButton.removeClass('ui-button-disabled');

            phvoDaButton.prop('disabled', false);
            phvoDaButton.removeClass('ui-state-disabled');
            phvoDaButton.removeClass('ui-button-disabled');
        }

        if (preventDA) {
            phvoDaButton.prop('disabled', true);
            phvoDaButton.addClass('ui-state-disabled');
            phvoDaButton.addClass('ui-button-disabled');
        }
    },

    chgDiv: function () {
        // Ändere den angezeigten div in der Direkt-Version
        // c is the button clicked
        var c = BC.get_id(this);
        var s = /div_step_(\d)$/;
        var r = c.match(s);
        // d_n = num of div next where to move to
        // d_s = div of next sibling
        var d, d_n, d_s, d_h;
        var step = 1;
        var d2show = '#div_';
        BC.debug('ALL.chgDiv(): Start', [c, r], 64);
        if (!r && c) {
            // d is the current visible div
            d = ALL.get_box_id(c);
            //ALL.chkDivReady(d);
            step = ALL.getMoveDir(this);
            d_n = d_h = parseInt(BC.get_id(d).split('_')[1]);
        } else if (r) {
            d = '#div_' + ALL.steps[0];
            d2show = d2show + r[1];
            d_n = d_h = parseInt(r[1]);
        } else {
            d = '#div_' + ALL.steps[0];
            d2show = d2show + ALL.steps[2];
            d_n = d_h = ALL.steps[2];
        }
        while (!JQ(d2show).length && d_n >= 0) {
            d_n = d_n + step;
            // Check for sibling:
            BC.debug('ALL.chgDiv(): siblings are ' + BC.get_id(JQ(d).prev()) + ' and ' + BC.get_id(JQ(d).next()), '', 64);
            d_s = BC.get_id(step < 0 ? JQ(d).prev() : JQ(d).next());

            BC.debug('ALL.chgDiv(): Sibling to move could be ' + d_s, '', 64);
            d2show = '#div_' + d_n;
            if (d_s != d2show && Math.abs(step) == 1) {
                // Show next / prev sibling instead of div d_n
                d2show = d_s;
                d_n = parseInt(d_s.split('_')[1]);
            }
            // Falls es ein Zusammenfassung-div ist, in  dem wir uns befinden:
            // Ausblenden
            if (JQ('#div_' + d_h + '_a').length) JQ('#div_' + d_h + '_a').addClass('hidden').hide();
        }
        BC.debug('ALL.chgDiv(): Want to move from ' + BC.get_id(d) + ' to ' + d2show + ', ALL.steps is:', ALL.steps, 64);
        ALL.notifyHeight();
        // CHECK if may move here!
        try {
            if (step > 0 &&
                ALL.steps[0] < 90 &&
                PRIV[ALL.branch] &&
                !PRIV[ALL.branch].chkDivReady(this) &&
                !ALL.chkDivMove(d_n)) return;
        } catch (e) {
            BC.debug('ALL.chgDiv(): Raised exception', e, 16);
            Sentry.captureException(e);
            return;
        }
        BC.debug('ALL.chgDiv(): Moving to: ' + d2show + ', ALL.steps is:', ALL.steps, 64);
        JQ(d2show).removeClass('hidden').show();
        JQ(d).addClass('hidden').hide();
        ALL.chgStateBar(d_n);
        JQ(window).scrollTop(0);
        //PRIV[ALL.branch].chkDivReady(d2show);
        ALL.chgMobButtons(ALL.branch);
        ALL.notifyHeight();
    },

    chgDiv2: function () {
        // Called by elements in statebar,
        // changes the visible div
        try {
            var t = BC.get_id(this);
            var n = parseInt(t.split('_')[2]);
            var tn = '#div_' + n;
        } catch (ex) {
            BC.debug('ALL.chgDiv2() failed with exception', ex);
            Sentry.captureException(ex);
            return;
        }
        BC.debug('ALL.chgDiv2(): clicked on ' + t + ', want to show ' + tn);
        if (!JQ(tn).length) return;
        // Hide all divs:
        JQ('div.box').filter(':visible').addClass('hidden').hide();
        // Show wanted div:
        JQ(tn).removeClass('hidden').show();
        // And update statebar
        ALL.chgStateBar(n);
        ALL.notifyHeight();
    },

    chgMobButton: function (btn_id, b) {
        // Change CSS of Button if it is possible to proceed
        BC.debug('ALL.chgMobButton(' + btn_id + ', ' + b + ')', '', 64);
        var btn = JQ(btn_id);
        var w = ALL.get_w_sizes();
        if (!btn.length || btn_id == '#btn_final') return;
        if (b) {
            btn.addClass('button_enabled').off('click').click(ALL.chgDiv);
            //BC.debug('ALL.chgMobButton(' + btn_id + ', ' + b + '): Trying to scroll ' + w.body_h, w, 64);
            if (ALL.steps[0] == 1) JQ(window).scrollTop(w.body_h);
        } else {
            btn.removeClass('button_enabled').off('click').click(ALL.chkDivReady);
        }
        ALL.notifyHeight();
    },

    chgMobButtons: function (product) {
        // Change state of:
        // - buttons in statebar
        // - fwd-buttons
        // if possible. Also set ALL.steps[1] to correct value
        BC.debug('ALL.chgMobButtons(' + product + ')', ALL.steps, 64);
        var b = true;
        var btn;
        if (PRIV[product] && PRIV[product]['chkDivReady'] && PRIV[product]['chkDivReady'].length) {
            b = PRIV[product].chkDivReady('#div_' + ALL.steps[0]);
        }
        if (JQ('#div_' + product + '_rslt').filter(':visible').length &&
            ALL.steps[1] <= 1) {
            ALL.steps[1] = 2;
        }
        BC.debug('ALL.chgMobButtons(' + product + '): Finally looping through all divs', ALL.steps, 64);
        for (var i = 0; i < ALL.steps[0]; i++) {
            btn = '#btn_fwd_' + i;
            if (JQ(btn).length) ALL.chgMobButton(btn, true);
        }
        btn = ALL.steps[0] < 98 ? '#btn_fwd_' + ALL.steps[0] : '#btn_final';
        BC.debug('ALL.chgMobButtons(): Setting ' + btn + ' to', b, 64);
        ALL.chgMobButton(btn, b);
        for (var i = ALL.steps[0] + 1; i < 6; i++) {
            btn = '#btn_fwd_' + i;
            if (JQ(btn).length) ALL.chgMobButton('#btn_fwd_' + i, false);
        }
    },

    chgProduct: function (product, btr) {
        var p = JQ('#div_' + product + '_rslt').length ? product : ALL.branch;
        // p ist das product oder branch name zb thv
        BC.debug('ALL.chgProduct(' + p + ', ' + btr + ')', '', 64);
        // rslt ist die div id zb #div_thv_rslt
        var rslt = '#div_' + p + '_rslt';
        BC.debug('ALL.chgProduct(' + rslt + ', ' + btr + ')', '', 64);
        if (!btr) {
            JQ('#f_all_' + p).text('0,00 €');
            ALL.showButton(p, false);
            JQ(rslt + ' .result').text('0,00 €');
            JQ(rslt).hide();
            JQ('#f_' + p + '_make').val(0);
        } else {
            JQ('#f_all_' + p).text(ALL.flt2cur(btr));
            //ALL.showButton(p, (btr >= 10));
            ALL.showButton(p, true);
            if (ALL.steps[1] <= 1) ALL.steps[1] = 2;
            if (ALL.mobile) {
                if (JQ(rslt).is(':hidden')) JQ(rslt).slideDown(1000);
                if (product !== "thv") {
                    ALL.chgMobButtons(p);
                }
                ALL.chgBtrZW(p);
            } else {
                JQ(rslt).show();
            }
            JQ('#f_' + p + '_make').val(1);
        }
        ALL.notifyHeight();
    },

    chgStateBar: function (n) {
        if (ALL.branch === "thv") {
            return;
        }

        var x = null;
        var s;
        var b = ALL.branch.slice(0, 4);
        if (b == 'phth') {
            s = 'statebar4';
            //} else if (b == 'unfa') {
            //    s = 'statebar6';
        } else {
            s = 'statebar5';
        }
        if (ALL.classof(n) !== 'Number') {
            x = ALL.get_box_id(this);
            BC.debug('ALL.chgStateBar() called with', x, 64);
            return;
        }
        if (!JQ('#statebar').is(':hidden') && (n == 0 || n == 99)) {
            // Hide statebar
            JQ('#statebar').removeClass(s).addClass('hidden').hide();
            JQ('#div_' + ALL.branch + '_rslt').hide();
        } else if (JQ('#statebar').is(':hidden') && n > 0 && n < 99) {
            // Enable statebar
            JQ('#statebar').removeClass('hidden').addClass(s).show();
        }
        BC.debug('ALL.chgStateBar() setting to:', n, 64);
        JQ('#div_step_' + n).removeClass('stepnum0').removeClass('stepnum2').addClass('stepnum1').html(n).off('click');
        for (var i = 1; i < n; i++) {
            JQ('#div_step_' + i).html('<img src="/images/chk_circle_red.svg" />').removeClass('stepnum1').addClass('stepnum2').click(ALL.chgDiv2);
        }
        for (var i = n + 1; i < 6; i++) {
            JQ('#div_step_' + i).removeClass('stepnum2').removeClass('stepnum1').addClass('stepnum0').html('').off('click');
        }
        ALL.steps[0] = n;
        ALL.notifyHeight();
    },

    chk_aCode: function (e) {
        var c = JQ(this).val();
        if (c.length < 4) return;
        JQ.getJSON(JSONURI,
            {
                action: 'chk_acode',
                acode: c,
                branch: PRIV.branch,
                sid: JQ('#f_sid').val()
            },
            ALL.set_aCode);
        return;
    },

    chkChanged: function (e) {
        BC.debug('ALL.chkChanged(): ', e.target.id, 64);
        var e_id = '#' + e.target.id;
        ALL.setFldsEnOrDisabled(e);
        // Set default VS 100k if not set already:
        if (e.target.name == 'inha_f' && ALL.chkChkBox('f_inha_f') && !JQ('#f_inha_vs').val()) JQ('#f_inha_vs').val(100);
        if (e.target.name == 'erta_f' && ALL.chkChkBox('f_erta_f') && !JQ('#f_erta_vs').val()) JQ('#f_erta_vs').val(100);
        if (e.target.name == 'geba_f' && ALL.chkChkBox('f_geba_f') && !JQ('#f_geba_vs').val()) JQ('#f_geba_vs').val(100);
        if (JQ(e_id).parents('#HaftVers').length) {
            BC.debug('ALL.chkChanged(): parents: ', [JQ(e_id).parents('#HaftVers'), JQ(e_id).parents()], 256);
            HAFT.reCalc();
        } else if (JQ(e_id).parents('#GebaVers').length) {
            SACH.chg_geba();
        } else if (JQ(e_id).parents('#div_sach_inha').length) {
            SACH.chg_inha();
            if (e_id == '#f_inhb_f' && ALL.chkChkBox(e_id)) {
                // Unset and recalc erta if kbu is enabled
                JQ('#f_erta_vs').val('');
                SACH.chg_erta();
            }
        } else if (JQ(e_id).parents('#div_sach_erta').length) {
            SACH.chg_erta();
            if (e_id == '#f_erta_f' && ALL.chkChkBox(e_id)) {
                // Unset and recalc inhb if erta is enabled
                //JQ('#f_inhb_f').val('');
                SACH.chg_inha();
            }
        }
    },

    chkChkBox: function (id) {
        // Prueft ob Checkbox id gesetzt ist oder nicht
        BC.debug('ALL.chkChkBox(' + id + ')', '', 64);
        var f = id;
        if (f.charAt(0) != '#') f = '#' + f;
        BC.debug('ALL.chkChkBox(' + f + ')', [JQ(f).length, JQ(f).is(':checked')], 64);
        return JQ(f).length && JQ(f).is(':checked');
    },

    chkContactData: function () {
        // Pruefe, ob Kontaktdaten schon im Formular eingetragen sind
        BC.debug('ALL.chkContactData()', '', 64);
        if ((!JQ('#f_email1').val() && !JQ('#f_direct').length) ||
            (JQ('#f_email1').length && !JQ('#f_email1').val())) {
            BC.debug('ALL.chkContactData()', 'retrieving vm-data', 64);
            JQ.getJSON(JSONURI,
                {
                    bv_action: 'contactdata',
                    sid: JQ('#f_sid').val()
                },
                ALL.setContactData);
        }
    },

    chkDate: function (e) {
        BC.debug('ALL.chkDate()', [this, e], 64);
        var branch, diff, dnls, ed, hints, sd;
        if (e.target) {
            e = e.target;
        }
        ALL.dates_ok = false;
        branch = ALL.get_branch(e);
        dnls = ALL.chkChkBox('f_' + branch + '_dnls');
        if (branch == 'vn') return;
        sd = ALL.date_chkStart(JQ('#f_' + branch + '_start'));
        ed = ALL.date_mk(JQ('#f_' + branch + '_ende').val());
        diff = ALL.date_diff(sd, ed, 'm');
        BC.debug('ALL.chkDate()', [branch, sd, ed, diff], 64);
        // IF sd is before today add to hints "Der Versicherungsbeginn darf nicht in der Vergangenheit liegen."
        if (diff < 12 && !dnls) {
            BC.debug('ALL.chkDate(): Duration too short, fixing', diff, 64);
            ed = new Date(sd.getFullYear() + 1, sd.getMonth(), sd.getDate(), 2);
            JQ('#f_' + branch + '_ende').val(ALL.date2str(ed));
            hints = 'Die Versicherungsdauer muss mindestens 1 ganzes Jahr betragen, das Ablaufdatum wurde entsprechend angepasst.';
        } else if (branch == 'bawe' && diff > 24) {
            BC.debug('ALL.chkDate(): Duration for BAWE too long, fixing', diff, 64);
            ed.setFullYear(sd.getFullYear() + 2, sd.getMonth(), sd.getDate());
            JQ('#f_' + branch + '_ende').val(ALL.date2str(ed));
            hints = 'Die Versicherungsdauer kann maximal 2 Jahre betragen, das Ablaufdatum wurde entsprechend angepasst.';
        } else if (dnls && diff < 36) {
            ed = new Date(sd.getFullYear() + 3, sd.getMonth(), sd.getDate(), 2);
            BC.debug('ALL.chkDate(): Duration for ' + branch + ' with DNLS too short, fixed to', [sd, ed, sd.getMonth(), sd.getDate()], 64);
            JQ('#f_' + branch + '_ende').val(ALL.date2str(ed));
            //hints = 'Die Versicherungsdauer bei Nutzung des Dauernachlasses muss mindestens 3 volle Jahre betragen, das Ablaufdatum wurde entsprechend angepasst.';
        } else if (!ALL.chkChkBox('f_' + branch + '_dnls') && diff >= 24) {
            BC.debug('ALL.chkDate(): Reducing end-date!', ed, 64);
            ed = new Date(sd.getFullYear() + 1, sd.getMonth(), sd.getDate(), 2);
            JQ('#f_' + branch + '_ende').val(ALL.date2str(ed));
        }
        ALL.dates_ok = true;
        if (ALL.showHints && hints) ALL.showHint(hints);
    },

    chkDivMove: function (d) {
        if (d > ALL.steps[1]) {
            BC.debug('ALL.chkDivMove(): Move not allowed!', [d, ALL.steps[1]], 32);
            ALL.steps[0] = ALL.steps[1];
            return false;
        }
        ALL.steps[0] = d;
        return true;
    },

    chkDivReady: function (div, NoErrs) {
        var d;
        if (!div || typeof (div) != 'string') {
            d = ALL.get_box_id(JQ(this).attr('id'));
        } else {
            d = ALL.get_box_id(div);
        }
        if (!d) return;
        var hint = '';
        var _id = '';
        var oid = '';
        var oks = [];
        BC.debug('ALL.chkDivReady() with div ' + d + ', NoErrs: ' + NoErrs, this, 64);
        var btn = JQ(this).hasClass('stepbtn') ? JQ(this).prop('id') : '';
        JQ(d + ' div,' +
            d + ' :input,' +
            d + ' a').each(function (i) {
            _id = JQ(this).attr('id');
            if (!JQ(this).attr('data-ctrltype') ||
                !_id ||
                JQ(this).is(':hidden')) {
                BC.debug('ALL.chkDivReady() - CANNOT check ', this, 512);
                return true;
            }
            hint = JQ(this).attr('data-ctrlhint') ? JQ(this).attr('data-ctrlhint') : 'Bitte wählen Sie';
            hint = '<p class="missing r19" id="hint_' + _id + '">' + hint.toUpperCase() + '</p>';
            BC.debug('ALL.chkDivReady() - checking: ', this, 64);
            switch (JQ(this).attr('data-ctrltype')) {
                case '0':
                    break;
                case '1':
                case '2':
                    if (JQ(this).val() ||
                        (JQ(this)[0].nodeName == 'DIV' &&
                            JQ('#' + _id + ' :input').val())) {
                        if (JQ('#hint_' + _id).length) JQ('#hint_' + _id).remove();
                        JQ(this).removeClass('missing');
                        return true;
                    } else if (_id == 'div_da_iban' &&
                        JQ('#hint_' + _id).length &&
                        JQ('#f_da_iban').val().length == 27 &&
                        chk_iban(JQ('#f_da_iban').val()) == '1' &&
                        JQ('#f_da_levok').is(':checked')) {
                        JQ('#hint_' + _id).remove();
                        JQ(this).removeClass('missing');
                        return true;
                    } else if (JQ('#hint_' + _id).length) {
                        return true;
                    } else if (!NoErrs) {
                        BC.debug('ALL.chkDivReady() / ! NoErrs with: ', this, 64);
                        if (!JQ(this).hasClass('c1_4')) {
                            if (JQ(this).children().length) {
                                JQ(hint).insertAfter(JQ(this).children().last());
                            } else {
                                JQ(hint).insertAfter(JQ(this));
                            }
                        } else {
                            JQ(hint).insertAfter(this);
                        }
                        JQ(this).addClass('missing');
                    }
                    ALL.notifyHeight();
                    break;
                case '3':
                case '4':
                    if (JQ(this).attr('data-ctrlok') != undefined &&
                        JQ(this).attr('data-ctrlok'))
                        oks = JQ(this).attr('data-ctrlok').split(',')
                    else
                        oks = [];
                    if (JQ('#' + _id + ' input:checked').length &&
                        (!oks.length ||
                            (oks && oks.indexOf(JQ('#' + _id + ' input:checked').val()) >= 0))) {
                        BC.debug('ALL.chkDivReady() - ctrltype 3 or 4', JQ('#' + _id + ' input:checked'), 64);
                        if (JQ('#hint_' + _id).length) JQ('#hint_' + _id).remove();
                        JQ(this).removeClass('missing');
                        ALL.notifyHeight();
                        return true;
                    } else if (JQ('#hint_' + _id).length) {
                        return true;
                    } else if (!NoErrs) {
                        JQ(hint).appendTo(this);
                        if (JQ(this).attr('data-ctrlnook'))
                            JQ('#hint_' + _id).text(JQ(this).attr('data-ctrlnook').toUpperCase());
                        JQ(this).addClass('missing');
                    }
                    break;
                case '5':
                    if (JQ('#' + _id + ':visited').length || PRIV.an_read) {
                        if (JQ('#hint_' + _id).length) JQ('#hint_' + _id).remove();
                        JQ(this).removeClass('missing');
                        ALL.notifyHeight();
                        return true;
                    } else if (JQ('#hint_' + _id).length) {
                        return true;
                    } else if (!NoErrs) {
                        JQ(hint).appendTo(this);
                        JQ(this).addClass('missing');
                        ALL.notifyHeight();
                    }
                    break;
                case '11':
                case '12':
                    // Value vorhanden, passt aber nicht
                    if (JQ('#hint_' + _id).length) return true;
                    JQ(hint).insertAfter(this);
                    JQ(this).addClass('missing');
                    ALL.notifyHeight();
                    break;
                default:
                    BC.debug('ALL.chkDivReady(): ', [JQ(this).prop('type'), JQ(this).prop('tagName')], 256);
                    break;
            }
        });
        if (btn && PRIV[ALL.branch] && PRIV[ALL.branch]['chk2']) {
            PRIV[ALL.branch]['chk2'](d);
            ALL.notifyHeight();
        }
    },

    chkDivReady2: function () {
        if (this.id.indexOf("dog-name") === 0) {
            return;
        }

        BC.debug('ALL.chkDivReady2()', this, 64);
        var i = JQ(this).attr('id');
        if (!i) return;
        i = '#' + i;
        ALL.chkDivReady(i, true);
    },

    chkError: function (data) {
        // Redirect page to data.redir if data.ERROR is true
        ALL.err = 0;
        if (!data && !data.DirA && !data.ERROR && !data.flds && !data.msg && !data.redir) return;
        BC.debug('ALL.chkError():', data, 64);
        if (data.DirA && data.branch == 'sach') {
            // Direktionsanfrage generieren statt alert und gleichzeitige VS-Korrektur!
            SACH.setDirAnfrage(data.DirA);
            ALL.err = 16;
            return;
        } else if ('DirA' in data && data.branch == 'sach') {
            // Direktionsanfrage-Property ist false => unset DirA
            SACH.setDirAnfrage(data.DirA);
        } else if (data.DirA && data.branch == 'haft') {
            HAFT.setDirAnfrage(data.DirA);
            ALL.err = 16;
            return;
        } else if ('DirA' in data && data.branch == 'haft') {
            // Direktionsanfrage-Property ist false => unset DirA
            HAFT.setDirAnfrage(data.DirA);
        }
        if (!data.ERROR) return;
        if (data.flds) {
            // Felder mit neuen Werten sind geliefert
            JQ.each(data.flds, function (k, v) {
                BC.debug('ALL.chkError(): => ', [k, v], 64);
                if (JQ('#' + v + ' [type="checkbox"]').length) {
                    BC.debug('ALL.chkError(): Checkbox found!', [k, v], 64);
                    JQ('#' + v).prop('checked', v);
                } else {
                    JQ('#' + k).val(v);
                }
            });
        }
        if (data.msg) {
            ALL.err = 1;
            ALL.showHint(data.msg, true);
        } else if (data.ERROR && data.DirA) {
            // Allgemeiner Direktionsanfragehinweis
            if (data.branch == 'phvo' && !JQ('#f_phvo_plz').val()) {
                JQ('#div_phvo_rslt').hide();
            } else {
                JQ('#div_' + data.branch + '_rslt').hide();
            }
            ALL.notifyHeight();
            ALL.chgMobButton('#btn_fwd_' + ALL.steps[0], false);
            // Ugly Quick fix for WALD-502
            if (data.DirA[0] === 'Für die angegebene Postleitzahl ist kein reiner Diebstahlschutz möglich.') {
                FHRD.handleDirA(data.DirA);
            }
            ALL.showHint(data.DirA, 1);
        } else if (data.ERROR && !data.redir) {
            // Allgemeiner Fehler wenn weder Fehlertext noch redirection gegeben sind.
            // Sollte nicht passieren ;-)
            ALL.err = 2;
            ALL.showHint('Ein Fehler ist aufgetreten, bitte prüfen Sie Ihre Eingaben');
        }
        if (data.redir) {
            ALL.err = 4;
            window.location.replace(data.redir);
        }
    },

    chkLength: function (o, n, min, max) {
        if (o.val().length > max || o.val().length < min) {
            o.addClass("ui-state-error");
            updateTips("Die Länge des Feldes " + n + " muss zwischen " +
                min + " und " + max + "betragen.");
            return false;
        } else {
            return true;
        }
    },

    chkOpt: function (id) {
        // Prüfe, ob (mindestens) eine Option bei Optionsgruppe ausgewählt wurde
        // id ist abweichend von der sonstigen Logik hier der Name des Options-Feldes
        // Also nicht #f_option_name_0, f_option_name_1 etc.
        // sondern 'input[name="' + option_name + '"]'
        // Keine Option ausgewählt:
        if (!JQ('input[name="' + id + '"]:checked').length) return false;
        // Liefere ersten ausgewählten Eintrag:
        return JQ('input[name="' + id + '"]:checked').val();
    },

    chkPWmatch: function () {
        var pw0 = JQ("#p_pw0").val();
        var pw1 = JQ("#p_pw1").val();

        if (pw0 != pw1) {
            $("#s_pw_comp").text("Passwörter stimmen nicht überein!");
        } else {
            $("#s_pw_comp").text("Passwörter sind identisch.");
        }
    },

    chkRegExp: function (o, regexp, n) {
        if (!(regexp.test(o.val()))) {
            o.addClass("ui-state-error");
            updateTips(n);
            return false;
        } else {
            return true;
        }
    },

    chkSET: function () {
        var b = true;
        JQ.each(ALL.set, function (k, v) {
            if (k == 'recalced') return true;
            b = b && v;
        });
        return b;
    },

    chkHNR: function (e) {
        var b = ALL.get_branch(this);
        ALL.adr.vn = b == 'vn';
        ALL.adr.phvo = b == 'phvo';
        // Nächste Zeile, um Sub-Sparten in PHV verarbeiten zu können ohne
        // PHTH.change() zu triggern:
        if (b.substr(0, 4) == 'phth') e.stopPropagation();
        BC.debug('ALL.chkHNR() ', [b, ALL.adr], 64);
        if (ALL.adr.vn) {
            ALL.adr.vn_hnr = JQ("#f_vn_hnr").val();
            return;
        } else if(ALL.adr.phvo) {
            ALL.adr.phvo_hnr = JQ("#f_phvo_hnr").val();
            return;
        }
        if (JQ("#f_" + b + "_hnr").val()) {
            JQ.getJSON(JSONURI,
                {
                    bv_action: 'zuers',
                    bv_str: JQ("#f_" + b + "_str").val(),
                    bv_hnr: JQ('#f_' + b + '_hnr').val(),
                    sid: JQ('#f_sid').val()
                },
                ALL.setHNR
            );
        } else {
            JQ('#s_zuersz_' + b).text('??');
        }
    },

    chkORT: function (e) {
        var b = ALL.get_branch(this);
        // Nächste Zeile, um Sub-Sparten in PHV verarbeiten zu können ohne
        // PHTH.change() zu triggern:
        if (b.substr(0, 4) == 'phth') e.stopPropagation();
        ALL.adr.vn = b == 'vn';
        ALL.adr.phvo = b == 'phvo';
        ALL.set.ORT = false;
        var s = (JQ("#f_" + b + "_ort").val() || JQ("#f_" + b + "_ort")[0].value)
        BC.debug('ALL.chkORT():', [b, s, JQ("#f_" + b + "_ort")[0].value], 64);
        if (JQ("#f_" + b + "_ort").val()) {
            JQ.getJSON(JSONURI,
                {
                    bv_action: 'list',
                    bv_type: 'strs',
                    bv_subtype: (JQ("#f_" + b + "_plz").val() + '_' +
                        JQ("#f_" + b + "_ort").val()),
                    sid: JQ('#f_sid').val()
                },
                ALL.setORT
            );
        } else {
            BC.debug('ALL.chkORT() - ORT unset or errornous', '', 32);
            JQ("#f_" + b + "_str").attr('readonly', true).prop('disabled', true).empty();
            JQ("#f_" + b + "_hnr").attr('readonly', true).prop('disabled', true).empty();
        }
    },

    chkPLZ: function (e) {
        var b = ALL.get_branch(this);
        ALL.adr.vn = b == 'vn';
        ALL.adr.phvo = b == 'phvo';
        BC.debug('ALL.chkPLZ()', [b, this, e], 512);
        // Nächste Zeile, um Sub-Sparten in PHV verarbeiten zu können ohne
        // PHTH.change() zu triggern:
        if (b.substr(0, 4) == 'phth') e.stopPropagation();
        var plz = JQ("#f_" + b + "_plz").val();
        ALL.set.PLZ = false;
        BC.debug('ALL.chkPLZ()', b, 64);
        if ((plz + '').search(/^\d{5}$/) == 0) {
            JQ("#f_" + b + "_ort").removeAttr("readonly");
            if (plz && !ALL.adr.vn) {
                ALL.PLZ = ALL.adr.plz = plz;
            } else if (plz) {
                ALL.PLZ = ALL.adr.vn_plz = plz;
            }
            JQ.getJSON(JSONURI,
                {
                    bv_action: 'list',
                    bv_type: 'orte',
                    bv_subtype: plz,
                    sid: JQ('#f_sid').val()
                },
                ALL.setPLZ
            );
        } else {
            BC.debug('ALL.chkPLZ() error!', '', 32);
            JQ("#f_" + b + "_plz").val('');
            JQ("#f_" + b + "_ort").empty().attr("readonly", true).prop('disabled', true);
            JQ("#f_" + b + "_str").val('').attr('readonly', true).prop('disabled', true);
            JQ("#f_" + b + "_hnr").val('').attr('readonly', true).prop('disabled', true);
            JQ("#err_plz").dialog('open');
            JQ("#f_" + b + "_plz").focus();
        }
    },

    chkSTR: function (event) {
        var b = ALL.get_branch(this);
        ALL.adr.vn = b == 'vn';
        ALL.adr.phvo = b == 'phvo';
        BC.debug('ALL.chkSTR() ', b, 64);
        JQ("#f_" + b + "_hnr").val(null);
        JQ("#f_" + b + "_gg").val(null);
        if (JQ("#f_" + b + "_str").length && JQ("#f_" + b + "_str").val()) {
            JQ("#f_" + b + "_hnr").attr('readonly', false);
            if (ALL.adr.vn) {
                ALL.adr.vn_snr = JQ('#f_vn_str').val();
                ALL.adr.vn_str = JQ('#f_vn_str option:selected').text();
            }
            if (ALL.adr.phvo) {
                ALL.adr.phvo_snr = JQ('#f_phvo_str').val();
                ALL.adr.phvo_str = JQ('#f_phvo_str option:selected').text();
            }
            JQ.getJSON(JSONURI,
                {
                    bv_action: 'list',
                    bv_type: 'hnr',
                    bv_subtype: JQ("#f_" + b + "_str").val(),
                    sid: JQ('#f_sid').val()
                },
                function (data) {
                    if (data.nl.length != 0) {
                        ALL.setSTR(data);
                    } else {
                        JQ("#f_" + b + "_hnr").attr('readonly', true).prop('disabled', true).empty();
                        ALL.showHint('Die Ausgewählte Straße wurde nicht gefunden!', 'Fehler!', true);
                    }
                }
            );
        } else {
            BC.debug('ALL.chkSTR() - STR unset or errornous', '', 32);
            JQ("#f_" + b + "_hnr").attr('readonly', true).prop('disabled', true).empty();
        }
    },

    classof: function (o) {
        // See book Javascript-Referenz DE Page 146
        if (o === null) return "Null";
        if (o === undefined) return "Undefined";
        return Object.prototype.toString.call(o).slice(8, -1);
    },

    clearForm: function (f) {
        // Funktion zum zurücksetzen eines Formulars
        // f ist das zurückzusetzende einschließende Elternelement
        // in JQ-Schreibweise (also z.B. '#div_unfa_vp'
        BC.debug('ALL.clearForm(): ', f, 64);
        var frm = JQ(f);
        frm.find(':checked').prop('checked', false);
        // Setze alle sonstigen input-Felder zurück:
        // Weitere Elemttypen auf http://wiki.selfhtml.org/wiki/Input
        //BC.debug('ALL.clearForm():', frm.find('input[type="text"]'), 256);
        //BC.debug('ALL.clearForm():', frm.find(':text'), 256);
        frm.find(':text').val('');
        frm.find('input[type="number"]').val(0);
        // Eventuell berechnete Felder auch zurücksetzen:
        frm.find('.calcedCurr').text('... €');
        frm.find('.calcedNum').text('...');
        BC.debug('ALL.clearForm(): ' + f + ' cleared', '', 64);
    },

    cur2flt: function (s) {
        // Wandel deutsche Währungszahl in rechenbares Format um, also
        // entferne 1.000er Punkt und ersetze Komma durch Punkt
        var n = parseFloat(s.replace('.', '').replace(',', '.'));
        return n;
    },

    date2str: function (d, f) {
        // Erzeugt aus dem Date-Objekt d einen String,
        // (derzeit nur dd.mm.yyyy)
        var dr = /(\d{4})-(\d{2})-(\d{2})T/;
        var s;
        try {
            s = d.toISOString().match(dr);
            s = s[3] + '.' + s[2] + '.' + s[1];
        } catch (e) {
            s = new Date();
            s = s.toISOString().match(dr);
            s = s[3] + '.' + s[2] + '.' + s[1];
        }
        return s;
    },

    date_chkStart: function (j) {
        // Prüfe Startdatum in JQ-Objekt j auf Gültigkeit
        var td = new Date();
        var t0 = ALL.date_mk();
        var d, hints;
        try {
            var sd = ALL.date_mk(j.val());
        } catch (e) {
            var sd = ALL.date_mk();
            BC.debug('ALL.date_chkStart() fehlgeschlagen', [j, e], 16);
            Sentry.captureException(e);
            return 0;
        }
        d = ALL.date_diff(td, sd);
        // if sd before td set sd to td
        if (sd < td) {
            sd = td;
            sd.setTime(sd.getTime() + 86400 * 1000);
            j.val(ALL.date2str(td));
        }
        if (d > 12) {
            // Das Beginndatum liegt zu weit in der Zukunft!
            sd = ALL.date_mk();
            sd.setYear(sd.getYear() + 1);
            j.val(ALL.date2str(sd));
            hints = 'Das angegebene Startdatum lag zu weit in der Zukunft und wurde angepasst';
        } else if (td.getHours() > 11 && sd < td) {
            // Frühestmöglicher Beginn ist morgen
            sd = ALL.date_mk();
            sd.setTime(sd.getTime() + 86400 * 1000);
            j.val(ALL.date2str(sd));
            hints = 'Ein Versicherungsbeginn heute oder früher ist nicht möglich, das Datum wurde korrigiert.';
        } else if (sd < t0) {
            // Beginndatum in der Vergangenheit
            sd = ALL.date_mk();
            j.val(ALL.date2str(sd));
            hints = 'Der Versicherungsbeginn lag in der Vergangenheit und wurde deshalb angepasst.';
        }
        if (ALL.showHints && hints) ALL.showHint(hints);
        return sd;
    },

    date_diff: function (s, e, i) {
        // Berechne die Differenz zwischen Startdatum s und Endedatum e
        // im Intervall i (derzeit nur m für Monat)
        // s und e müssen Date-Objekte sein
        var c, diff;
        try {
            if (i == 's') {
                // Liefere Differenz in Sekunden
                return (e - s) / 1000;
            }
            if (e.getDate() < s.getDate()) {
                c = -(s.getDate() - e.getDate());
            } else {
                c = e.getDate() - s.getDate();
            }
            diff = e.getFullYear() * 12 + e.getMonth() - s.getFullYear() * 12 - s.getMonth() + c / 30;
        } catch (e) {
            BC.debug('ALL.date_diff(): Fehler bei Berechnung Datumsdifferenz', [s, e], 16);
            Sentry.captureException(e);
            diff = 0;
        }
        return diff;
    },

    date_mk: function (s) {
        // Erzeugt aus dem string s in der Form dd.mm.jjjj ein Date-Objekt
        if (!s) {
            return;
        }
        var dr = /(\d{2})\.(\d{2})\.(\d{4})/;
        try {
            var r = s.match(dr);
            var d = new Date(r[3] + '-' + r[2] + '-' + r[1]);
        } catch (e) {
            Sentry.captureException(e);
            var d = new Date();
            d.setUTCHours(0, 0, 0, 0);
        }
        return d;
    },

    deserial: function (a) {
        // Unfortunatelly jquery does not have a function creating objects from arrays
        var o = {};
        if (!a) return o;
        JQ.each(a, function (i, v) {
            o[v.name] = v.value;
        });
        return o;
    },

    endisFlds: function (data) {
        // Generische Funktion fuer das enablen/disablen von Feldern,
        // ersetzt die alte toggle_kbu-Funktion in sach.js
        BC.debug('ALL.endisFlds() - data:', data, 128);
        BC.debug('ALL.endisFlds() - Flds:', ALL.FldsAll, 128);
        BC.debug('All.endisFlds() - Fld: ', data.target.id, 128);
        ALL.getFldsSet();
    },

    fillField: function (fk, fv) {
        // Fülle einzelnes Feld "fk" mit Wert "fv" bzw.
        // setze entsprechendes optionfield

        var f = JQ('#f_' + fk);
        // THV does not use the f_ prefix
        if (fk.startsWith('thv') && !f.length) {
            f = JQ('#' + fk);

            if (!f.length) {
                f = JQ('[name=' + fk + ']');
            }

            if (!f.length || f.length > 1 || f[0].tagName !== 'INPUT' && f[0].tagName !== "TEXTAREA") {
                if (f[0].tagName === 'SELECT') {
                    f = JQ('select[name=' + fk + '] > option[value=' + fv + ']');
                    f.prop("selected", true);
                    f.change();
                } else {
                    f = JQ('[name=' + fk + '][value=' + fv + ']');
                    if (f.prop("type") == "radio") {
                        f.click();
                    }
                }
            }

            // Check if breed is still insurable
            if (f.hasClass('thv-breed')) {
                JQ.getJSON('/TR/json?action=dogbreeds&term=' + fv, function (data) {
                    if (!data[0]) {
                        ALL.showHint('Es ist ein Fehler bei der überprüfung der Hunderasse passiert');
                    }

                    if (!data[0].accepted) {
                        ALL.showHint('Die ausgewählte Hunderasse (' + data[0].name + ') ist über die Waldenburger Versicherung AG nicht versicherbar.');
                    } else {
                        f.addClass('is-insurable');
                        f.change();
                    }
                });
            }
        }
        var fn;
        if (!f.length) {
            fn = '#f_' + fk + '_' + String(fv).split(' ', 1)[0];
            try {
                fn = fn.replace('+', 'p');
                f = JQ(fn);
            } catch (e) {
                BC.debug('ALL.fillField(): Missing field => ', [fk, fv, fn], 64);
                Sentry.captureException(e);
                return;
            }
            if (!f.length) return;
        }
        BC.debug('ALL.fillField() => Field: ' + BC.get_id(f) + ', Type: ' + f.prop('type') + ', Val: ' + fv, '', 256);
        if (f.prop('type') == 'radio') {
            f.prop('checked', true);
        } else if (f.prop('type') == 'checkbox' && parseInt(fv)) {
            BC.debug('ALL.fillField(): Setting ' + BC.get_id(f) + ' to ' + fv, '', 256);
            f.prop('checked', true);
            f.change();
        } else if (f.prop('type') == 'checkbox') {
            BC.debug('ALL.fillField(): UN-Setting ' + BC.get_id(f) + ' to ' + fv, '', 256);
            f.prop('checked', false);
        } else if (f.prop('type') == 'select-one') {
            JQ('#f_' + fk).val(fv).change();
            if (fk === 'hara2_frd_vs' && !ALL.mobile) {
                JQ('#f_hara2_frd_vs').change(function () {
                    JQ('#frd_kasko_first_option').prop('selected', true);
                })
                JQ('#f_hara2_frd_vs_kasko').change(function () {
                    JQ('#o_hara2_frd_0p').prop('selected', true);
                })
                JQ('#f_hara2_frd_vs > option').each(function (i, e) {
                    JQ(e).text(i + '% = ' + ALL.flt2cur(i * HARA.vs * 10))
                })
            }
            if (fk === 'hara2_frd_vs_kasko' && !ALL.mobile) {
                JQ('#f_hara2_frd_vs_kasko > option').each(function (i, e) {
                    JQ(e).text(i + '% = ' + ALL.flt2cur(i * HARA.vs * 10))
                })
            }
        } else {
            f.val(fv);
            f.change();
        }
        ALL.notifyHeight();
    },

    fillFormWithData: function (data) {
        // Fülle Formular mit Angebotsdaten,
        // callback-function für loadOffer
        var b;
        BC.debug('ALL.fillFormWithData(): data =>', data, 64);
        if (data.ERROR) {
            ALL.showHint(data.msg);
            return;
        }
        ALL.branch = data._branch || data.branch;
        if (ALL.branch.slice(0, 4).toLowerCase() == 'unfa' && UNFA.length) UNFA.vps = {};
        ALL.data = data;
        // 1. Fülle VN-Daten:
        ALL.fillVN();
        // 2. Fülle Risiko-Objekt-Daten
        ALL.fillObjAdr();

        if (ALL.branch === 'thv') {
            THV.blockRequest = true; /// prevent unnecessary requests
        }

        JQ.each(data, function (k, v) {
            if (!v || k == 'vps' || k == 'adr') return true;
            ALL.fillField(k, v);
        });

        if (ALL.branch === 'thv') {
            THV.blockRequest = false; /// enable normal processing
        }

        if (data.vps) {
            ALL.chkDate(data);
            // Eventuell vorhandene VPs löschen!
            JQ('a.dele').click();
            UNFA.set_vps(data.vps);
        }
        JQ('#a_' + ALL.branch + '_show').click();
        JQ('#div_' + ALL.branch + '_vers').change();
        if (!PRIV.calcable && !data[ALL.branch + '_plz']) {
            BC.debug('ALL.fillFormWithData(): ' + ALL.branch + ' does not have plz, assume it is calcable', '', 64);
            PRIV.calcable = true;
        }
        if (!ALL.set.recalced) {
            BC.debug('ALL.fillFormWithData(): Recalculating premium', '', 64);
            ALL.showHints = false;
            ALL.chkDate(data);
            ALL.showHints = true;
            JQ('#div_' + ALL.branch + '_vers').change();
            ALL.set.recalced = true;
        }
        if (data.branch === 'hara2' && data.hara2_frd_vs_kasko !== "0") {
            JQ('#f_hara2_frd_vs_kasko > option').each(function (i, e) {
                if (i === parseInt(data.hara2_frd_vs_kasko)) {
                    JQ(e).prop('selected', true);
                }
            });
        }
        ALL.notifyHeight();
    },

    fillObjAdr: function () {
        BC.debug('ALL.fillObjAdr()', '', 64);
        ALL.branch = ALL.data.branch || ALL.data._branch;
        if (!ALL.data.adr || !ALL.data.adr.obj || !ALL.data[ALL.branch + '_str']) return;
        var options = [];
        JQ.each(['ol', 'sl', 'nl'], function (i, v) {
            ALL.fillOlist('obj', v);
        });
    },

    fillOlist: function (branch, type, data) {
        BC.debug('ALL.fillOlist(): branch: ' + branch + ', type: ' + type, '', 64);
        var options = [];
        var d = null;
        var fld;
        if (data && data[type]) {
            d = data[type];
        } else if (ALL.data && ALL.data.adr && ALL.data.adr[branch] && ALL.data.adr[branch][type]) {
            d = ALL.data.adr[branch][type];
        } else {
            return;
        }
        JQ.each(d, function (key, val) {
            if (type == 'ol') {
                options.push("<option>" + val.or_ort + "</option>");
            } else if (type == 'sl') {
                options.push('<option value="' + val.st_id + '">' + val.st_strasse + '</option>');
            } else if (type == 'nl') {
                options.push('<option>' + val.nr_nr + '</option>');
            }
        });
        if (branch == 'vn') {
            if (type == 'ol') {
                fld = '#f_vn_ort';
                ALL.adr.vn_olist = options;
                if (d.length) ALL.adr.vn_ort = d[0].or_ort;
            } else if (type == 'sl') {
                fld = '#f_vn_str';
                ALL.adr.vn_slist = options;
                if (d.length) {
                    ALL.adr.vn_snr = d[0].st_id;
                    ALL.adr.vn_str = d[0].st_strasse;
                }
            } else if (type == 'nl') {
                fld = '#f_vn_hnr';
                ALL.adr.vn_hlist = options;
                if (d.length) ALL.adr.vn_hnr = d[0].nr_nr;
            } else {
                return;
            }
            JQ(fld).empty().append(options).attr("readonly", false).prop('disabled', false);
        } else if (branch == 'phvo') {
            if (type == 'ol') {
                fld = '#f_phvo_ort';
                ALL.adr.phvo_olist = options;
                if (d.length) ALL.adr.phvo_ort = d[0].or_ort;
            } else if (type == 'sl') {
                fld = '#f_phvo_str';
                ALL.adr.phvo_slist = options;
                if (d.length) {
                    ALL.adr.phvo_snr = d[0].st_id;
                    ALL.adr.phvo_str = d[0].st_strasse;
                }
            } else if (type == 'nl') {
                fld = '#f_phvo_hnr';
                ALL.adr.phvo_hlist = options;
                if (d.length) ALL.adr.phvo_hnr = d[0].nr_nr;
            } else {
                return;
            }
            JQ(fld).empty().append(options).attr("readonly", false).prop('disabled', false);
            JQ('#btn_set_plz_ort').show()
        } else if (branch == 'obj') {
            if (type == 'ol') ALL.adr.olist = options;
            else if (type == 'sl') ALL.adr.slist = options;
            else if (type == 'nl') ALL.adr.hlist = options;
            JQ.each(ALL.branches, function (i0, v0) {
                if ((ALL.branch == 'bawe' && v0 != 'bawe') || (ALL.branch != 'bawe' && v0 == 'bawe')) return true;
                if ((ALL.branch == 'phvo' && v0 != 'phvo') || (ALL.branch != 'phvo' && v0 == 'phvo')) return true;
                if (type == 'ol') fld = '#f_' + v0 + '_ort';
                else if (type == 'sl') fld = '#f_' + v0 + '_str';
                else if (type == 'nl') fld = '#f_' + v0 + '_hnr';
                else return true;
                if (!JQ(fld).length) return true;
                JQ(fld).empty().append(options).attr("readonly", false).prop('disabled', false);
            });
        }
        ALL.notifyHeight();
    },

    fillVN: function () {
        BC.debug('ALL.fillVN()', ALL.data, 64);
        if (!ALL.data || !ALL.data.vn_nachname || !ALL.data.adr || !ALL.data.adr.vn) return;
        JQ.each(['ol', 'sl', 'nl'], function (i, v) {
            ALL.fillOlist('vn', v);
        });
        JQ.each(ALL.data, function (k, v) {
            if (!v) return true;
            if (k.slice(0, 3) == 'vn_' ||
                (k == 'email1' || k == 'email2')) {
                JQ('#f_' + k).val(v);
                delete ALL.data[k];
            }
        });
    },

    flt2cur: function (n) {
        // Wandel Zahl in Währung in deutschem Format um
        if (typeof n != 'number') {
            BC.debug('ALL.flt2cur(): Problem converting ' + n, n, 512);
            return n;
        }
        var s = n.toFixed(2);
        var p = s.split('.');
        if (p[0].length > 3) {
            var m = p[0].length % 3;
            s = (m > 0 ? (p[0].slice(0, m)) : '');
            for (var i = 0; i < Math.floor(p[0].length / 3); i++) {
                if (!m || !i) {
                    s += '.';
                }
                s += p[0].slice(m + 3 * i, m + 3 * i + 3);
            }
        } else {
            s = p[0];
        }
        return s + ',' + p[1] + ' €';
    },

    getFldsSet: function () {
        // Get a list with all form-fields having a value <> false, 0 etc.
        BC.debug('ALL.getFldsSet()', '... starting ...', 128);
        JQ('input[type=checkbox], input[type=number], input[type=hidden], input:text, input:checked').each(function (i) {
            if (JQ(this).is(':checkbox') && !JQ(this).is(':checked')) {
                ALL.FldsSet[this.name] = false;
            } else if (JQ(this).is(':checked') || JQ(this).val() || Boolean(JQ(this).val())) {
                BC.debug('ALL.getFldsSet(): i: ', [i, ' this: ', this, JQ(this).val()], 256);
                ALL.FldsSet[this.name] = JQ(this).val();
            }
        });
        BC.debug('getFldsSet(): Fields set:', ALL.FldsSet, 128);
    },

    get_box_id: function (d) {
        BC.debug('ALL.get_box_id(): ' + typeof (d), d, 256);
        var e;
        if (!d) {
            return '';
        } else if (typeof (d) == 'string') {
            if ((d.slice(0, 3) == 'div' || d.slice(0, 4) == '#div') && d.length < 8) {
                BC.debug('ALL.get_box_id() - called with my result!?!?', d, 256);
                return d;
            }
            if (d.slice(0, 1) != '#') d = '#' + d;
            e = JQ(d).first();
        } else if (typeof (d) == 'object') {
            try {
                e = JQ(d);
            } catch (ex) {
                BC.debug('ALL.get_box_id() failed with object', d, 16);
                Sentry.captureException(ex);
                return '';
            }
        } else if (typeof (d) == 'number' && JQ('#div_' + d).length) {
            return '#div_' + d;
        } else {
            BC.debug('ALL.get_box_id() - called with:', d, 64);
            return '';
        }
        if (e.hasClass('stepnum1') || e.hasClass('stepnum2')) {
            // Sonderfall: Es wurde auf einen der klickbaren Punkte in der Statebar geklickt
            // Liefere ID des div mit class box, die die gleiche Nummer hat
            // Falsch! Die stepnum-ID ist ja die ID, WO es hin soll
            //return JQ('#div_' + BC.get_id(JQ(d)).split('_')[2]);
            // Also liefere div, in dem wir uns gerade befinden!
            return '#div_' + ALL.steps[0];
        } else if (!e.length) {
            BC.debug('ALL.get_box_id() - element not found: ', d, 16);
            return '';
        }
        try {
            BC.debug('ALL.get_box_id() - Searching div-parent of', e, 256);
            e = e.parents('.box, #div_0').first();
            if (!e.length) {
                BC.debug('ALL.get_box_id() - no parent found for ', d, 16);
                return '';
            }
            return BC.get_id(e);
        } catch (ex) {
            BC.debug('ALL.get_box_id() failed', ex, 16);
            Sentry.captureException(ex);
            return '';
        }
    },

    get_branch: function (e) {
        // Liefert die Sparte des Feldes, also z.B. muri, hara, glas etc.
        // Die Sparte ist in den IDs i.d.R. der zweite Teil der durch
        // "_" geteilten IDs (z.B. f_hara_wf oder f_hara1_frd)
        BC.debug('ALL.get_branch()', e, 512);
        if (e.branch || e._branch) return e.branch || e._branch;
        var b = BC.get_id(e).split('_');
        if (b.length >= 2 && b[1] != 'vn' && b[1].slice(0, 2) != 'da') {
            ALL.branch = b[1];
        } else if (b.length < 2 && b[0].slice(0, 2) != 'vn' && b[0].slice(0, 2) != 'da') {
            ALL.branch = b[0].slice(0, 4);
        } else {
            return 'vn';
        }
        return ALL.branch;
    },

    getMoveDir: function (e) {
        var x = BC.get_id(e);
        BC.debug('ALL.getMoveDir(): Clicked on ' + x + ', ALL.steps is', ALL.steps, 64);
        if (x.split('_')[1] == 'fwd') return 1;
        if (x.split('_')[1] == 'bck') return -1;
        if (x.split('_')[1] == 'step') {
            var want2s = parseInt(x.split('_')[2]);
            BC.debug('ALL.getMoveDir(): Want to div_' + want2s, '', 64);
            return want2s - ALL.steps[0];
        }
        BC.debug('ALL.getMoveDir(): Returning default 1', '', 64);
        return 1;
    },

    get_w_sizes: function () {
        var w = JQ(window);
        var b = JQ('body');
        ALL.view = {
            'body_h': b.height(),
            'body_w': b.width(),
            'win_h': w.height(),
            'win_l': w.scrollLeft(),
            'win_t': w.scrollTop(),
            'win_w': w.width()
        };
        return ALL.view;
    },

    getYN: function (i) {
        return ALL.chkChkBox(i) ? 'Ja' : 'Nein';
    },

    haveVN: function () {
        var missing = [];
        var m = '';
        var vn_set = ALL.vn_set;
        var gebdat = JQ('#f_vn_gebdat').val();
        if (!JQ('#f_vn_nachname').val().trim()) {
            m = 'Nachname VN';
            if (missing.indexOf(m) == -1) missing.push(m);
        }
        if ((JQ('#f_vn_anrede').val() == '1' ||
            JQ('#f_vn_anrede').val() == '2' ||
            JQ('#f_vn_anrede').val() == '5')) {

            JQ('#l_vn_nachname').text("Nachname");
            JQ('#f_vn_nachname').prop('placeholder', "Nachname");
            JQ('#f_vn_gebdat').prop('required', true);
            JQ('#f_vn_vorname').prop('required', true);
            JQ('#f_vn_gebdat').parent().show();
            JQ('#f_vn_vorname').parent().show();

            if (!gebdat.trim()) {
                m = 'Geburtsdatum VN';
                if (missing.indexOf(m) === -1) missing.push(m);
            }

        } else if (JQ('#f_vn_anrede').val() === '4') {
            JQ('#l_vn_nachname').text("Firma");
            JQ('#f_vn_nachname').prop('placeholder', "Firmenname");
            JQ('#f_vn_gebdat').prop('required', false);
            JQ('#f_vn_vorname').prop('required', false);
            JQ('#f_vn_gebdat').parent().hide();
            JQ('#f_vn_vorname').parent().hide();
        }
        gebdat = moment(gebdat, 'DD.MM.YYYY');
        if (gebdat.isValid() && gebdat.add(18, 'y').isAfter(moment())) {
            ALL.showHint('Für den Versicherungsabschluss ist ein Mindestalter von 18 Jahren erforderlich.');
            m = 'Geburtsdatum VN';
            if (missing.indexOf(m) == -1) missing.push(m);
        }
        if (!JQ('#f_vn_plz').val()) {
            m = 'PLZ';
            if (missing.indexOf(m) == -1) missing.push(m);
        } else {
            ALL.adr.vn_plz = JQ('#f_vn_plz').val();
        }
        if (!JQ('#f_vn_ort').val()) {
            m = 'Ort';
            if (missing.indexOf(m) == -1) missing.push(m);
        } else {
            ALL.adr.vn_ort = JQ('#f_vn_ort').val();
        }
        if (!JQ('#f_vn_str').val()) {
            m = 'Strasse';
            if (missing.indexOf(m) == -1) missing.push(m);
        }
        if (!JQ('#f_vn_hnr').val()) {
            m = 'Hausnummer';
            if (missing.indexOf(m) == -1) missing.push(m);
        }
        if (JQ('#f_vn_email').length) {
            m = 'Mail-Adresse';
            if (!JQ('#f_vn_email').val().trim()) {
                JQ('#f_vn_email').attr('data-ctrlhint',
                    JQ('#f_vn_email').attr('data-ctrlhint0'));
                JQ('#f_vn_email').attr('data-ctrltype', '1');
            } else if (!mailExpr.test(JQ('#f_vn_email').val().trim())) {
                JQ('#f_vn_email').attr('data-ctrlhint',
                    JQ('#f_vn_email').attr('data-ctrlhint1'));
                JQ('#f_vn_email').attr('data-ctrltype', '11');
            } else {
                m = '';
                JQ('#f_vn_email').attr('data-ctrlhint',
                    JQ('#f_vn_email').attr('data-ctrlhint0'));
                JQ('#f_vn_email').attr('data-ctrltype', '1');
            }
            if (m && (ALL.direct || ALL.mobile) && missing.indexOf(m) == -1) missing.push(m);
        }

        if (JQ('#f_vn_mobnr').length) {
            m = 'Mobilfunknummer';
            if (!JQ('#f_vn_mobnr').val().trim()) {
                JQ('#f_vn_mobnr').attr('data-ctrlhint',
                    JQ('#f_vn_mobnr').attr('data-ctrlhint0'));
                JQ('#f_vn_mobnr').attr('data-ctrltype', '1');
            } else if (!JQ('#f_vn_mobnr').val().trim().match(/^\+|(01)/)) {
                if (!ALL.direct && !ALL.mobile) {
                    ALL.showHint('Die Mobilfunknummer des Versicherungsnehmers wird für den sicheren, elektronischen Dokumentenversand benötigt')
                }

                JQ('#f_vn_mobnr').attr('data-ctrlhint',
                    JQ('#f_vn_mobnr').attr('data-ctrlhint1'));
                JQ('#f_vn_mobnr').attr('data-ctrltype', '11');
            } else {
                m = '';
                JQ('#f_vn_mobnr').attr('data-ctrlhint',
                    JQ('#f_vn_mobnr').attr('data-ctrlhint0'));
                JQ('#f_vn_mobnr').attr('data-ctrltype', '1');
            }
            if (m && (ALL.direct || ALL.mobile) && missing.indexOf(m) == -1) missing.push(m);
        }

        if (JQ('#f_vn_referenz').length && JQ('#f_vn_referenz').prop('required') && !JQ('#f_vn_referenz').val().trim()) {
            m = 'Externe_Referenz';
            if (missing.indexOf(m) == -1) missing.push(m);
        }


        if (JQ('#f_email1').length &&
            (!JQ('#f_email1').val().trim() ||
                !mailExpr.test(JQ('#f_email1').val().trim())) &&
            !JQ('#f_vn_email').val().trim()) {
            m = 'Mail-Adresse für Angebot';
            if (missing.indexOf(m) == -1) missing.push(m);
        }

        if (JQ('#f_hara2_ds_1').length &&
            !JQ('#f_hara2_ds_1').is(':checked')) {
            m = 'Bestätigung Datenschutzerklärung';
            if (missing.indexOf(m) == -1) missing.push(m);
        }
        ALL.vn_set = missing.length ? false : true;
        BC.debug('ALL.haveVN(): => ', [ALL.vn_set, missing], 64);
        ALL.chgButtons(ALL.vn_set);
        if (ALL.vn_set && !vn_set) {
            JQ('#div_outer_all_hints').show();
            if (!ALL.direct) {
                JQ('#div_inner_all_hints').html('Mit dem Klick auf eine der folgenden Schaltflächen (z.B. <i>Anträge per eMail versenden</i>) bestätigen Sie die Kenntnisnahme der <a href="https://www.waldenburger.com/datenschutz" class="ilink" target="_new">Datenschutzerklärung nach der DSGVO (Stand: 01.05.2018)</a>. Sobald Sie den Button <span class="underlined">Angebot anzeigen / speichern</span> betätigen, wird das Angebot im Reiter Angebote gespeichert. Sobald Sie den Button <i>"Angebote ... per eMail ... versenden"</i> betätigen, erhalten Sie eine E-Mail mit dem bzw. den Angeboten. Eine spätere Bearbeitung ist dann nicht möglich.');
            } else {
                JQ('#div_inner_all_hints').html('Mit dem Klick auf eine der folgenden Schaltflächen (z.B. <i>Anträge per eMail versenden</i>) bestätigen Sie die Kenntnisnahme der <a href="https://www.waldenburger.com/datenschutz" class="ilink" target="_new">Datenschutzerklärung nach der DSGVO (Stand: 01.05.2018)</a>.');
            }
        } else if (!ALL.vn_set) {
            JQ('#div_outer_all_hints').show();
            JQ('#div_inner_all_hints').html('Sobald alle Angaben zum Versicherungsnehmer vorhanden sind, können Sie die Angebote bzw. Anträge mittels der entsprechenden Buttons erstellen.<br /><br />');
        }
        // reload the error messages for the current form
        ALL.chkDivReady('#div_4');
        ALL.chkDivReady('#div_vn');
        ALL.notifyHeight();
        return ALL.vn_set;
    },

    hideHint: function () {
        JQ('#overlay').hide();
        JQ('div.infoField').hide();
        JQ('#div_error').hide();
    },

    initDoc: function (adminForm) {
        if (adminForm === 'admin') {
            JQ.getJSON(JSONURI, {action: 'get_usergroups'}, ADM0.currentUserGroups)
        }
        // Initialisierungsroutine für spartenübergreifende Funktionen
        // Kann dann in der spartenbezogenen JS-Datei bei document.ready() eingebaut werden

        // Zweite Maustaste: Individual-Menü XXX
        //(document).bind('contextmenu', function(e) {
        //  ALL.showHint('Menü für zweite Maustaste kommt in Kürze');
        //  return false;
        //});

        // Tabbed Form:
        JQ('#tabs').tabs();

        ALL.direct = JQ('#f_direct').length ? true : false;
        ALL.mobile = JQ('#f_mobile').length ? true : false;
        if (JQ('#f_branch').length && JQ('#f_branch').val()) ALL.branch = JQ('#f_branch').val();

        // Tooltips fuer die gesamte Berechnungsseite einschalten,
        // aber nicht für die neuen Seiten u.a. für mobile Devices:
        if (!ALL.mobile) {
            JQ(document).tooltip({
                classes: {"ui-tooltip": "ui-corner-all ui-widget-shadow"},
                content: function () {
                    return JQ(this).prop('title');
                },
                position: {collision: 'flipfit'}
            });
        }
        // Masking plz and type="number" crash!
        //JQ('.plz').inputmask('99999');
        // GebDat-Felder ohne Datepicker!
        JQ('.gebdat').mask('99.99.9999');
        //JQ('.gebdat').datepicker({changeMonth: true, changeYear: true, defaultDate: '-18y', maxDate: '-18y', minDate: '-99y', showOn: 'focus', yearRange: '-99:-18'});
        JQ('.today').val(today).datepicker({showOn: 'both'});
        JQ('.year').val(year); //.mask('9999', {reverse: true});
        // Standardwerte setzen, insbesondere Beginndaten:
        JQ('.vstart').val(tomorrow).mask('99.99.9999');
        JQ('.vstart').change(ALL.chkDate);
        //if (! ALL.mobile)
        JQ('.vstart').datepicker({
            changeMonth: true,
            changeYear: true,
            defaultDate: '+1d',
            maxDate: '+1y',
            minDate: 1,
            showOn: ALL.mobile ? 'focus' : 'both',
            yearRange: '-0:+1'
        });
        JQ('.vende').val(tomorrowInOneYear).mask('99.99.9999');
        JQ('.vende').change(ALL.chkDate)
        if (!ALL.mobile) {
            JQ('.vende').datepicker({showOn: 'both', minDate: 1});
        }
        JQ('.vdate').val(in2days).datepicker({showOn: 'both'});
        JQ('#f_da_iban').mask('DE99 9999 9999 9999 9999 99');
        JQ('svg.cb, .hidehint').click(ALL.hideHint);
        JQ('img.infobtn').click(ALL.showInfo);
        JQ('img.infobtn2').click(ALL.showInfo);
        JQ('img.pencil').click(ALL.move2input);
        if (ALL.mobile) {
            JQ('#a_da_offer').click(ALL.post_all);
            JQ('#btn_final').click(ALL.post_all);
        }

        // Verhindere Formular-POSTs mit Return-Taste:
        JQ('form input').on('keypress', function (e) {
            return e.which !== 13;
        });
        // Fehler- und Hinweisdialoge aktivieren
        // Alle divs mit class=errDialog können so als popup-Hinweis getriggert werden
        JQ(function () {
            JQ('.errDialog').dialog({
                autoOpen: false,
                modal: true,
                buttons: {
                    Ok: function () {
                        JQ(this).dialog('close');
                    }
                }
            });
            if (ALL.mobile) {
                JQ('#div_hint_generic').dialog('option', 'buttons',
                    [{
                        text: 'SCHLIESSEN',
                        click: function () {
                            JQ(this).dialog('close');
                        }
                    }]);
            }
        });

        JQ('.rbts').change(function () {
            // Max-Rabatt ggf. zurücksetzen
            var i = parseInt(JQ(this).val());
            var m = parseInt(JQ(this).attr('max'));
            if (isNaN(i)) i = 0;
            if (isNaN(m)) i = 0;
            if (i > m) JQ(this).val(m);
        });

        // "Kaufen"-Buttons in Prämienübersicht aktivieren
        JQ('.go2datavn').button({
            text: true,
            disabled: true,
        }).click(function () {
            JQ('#a_datavn').click()
        });

        JQ('#btn_chg_pw').button({
            text: true,
        }).click(function () {
            if (ALL.loadQueryParam.h === '1') {
                location = '/TR/admin?h=1'
            } else {
                location = '/TR/admin'
            }
        });

        JQ('#btn_logout').button({
            text: true,
        }).click(function () {
            location = '/TR/logout'
        });

        JQ('#f_vn_mobnr').change(ALL.haveVN);

        JQ('#f_vn_mobnr').change(ALL.haveVN);

        ALL.us_id = parseInt(JQ('#f_us_id').val());
        ALL.hideHint();

        // Time-Out-Trigger, der logout aufruft nach Inaktivität, die
        // in maxIdle definiert ist
        ALL.timeOut();
        if (!ALL.direct && !ALL.mobile) ALL.loadOffer();
        try {
            PRIV.init();
        } catch (e) {
            BC.debug('ALL.init() caught an exception:', e, 16);
        }
        ALL.notifyHeight();
    },

    isbetween: function (t, r) {
        // Prüfe ob Zahl t in der range r liegt. r ist ein array aus 2 Zahlen
        var v = parseInt(t);
        BC.debug('ALL.isbetween()', [t, v, r, v >= r[0] && v <= r[1], isNaN(v), r.length], 512);
        if (isNaN(v) || r.length != 2) return false;
        return (v >= r[0] && v <= r[1]);
    },

    isVNcompleted: function () {
        // Prüfe ob alle Angaben zum VN gemacht wurden
        var f;
        var r = true;
        for (var i = 0; i < ALL.mustVN.length; i++) {
            if (!ALL.mustVN[i]) continue;
            f = ALL.mustVN[i][0];
            if (JQ(f).length && JQ(f).is(':checkbox') && !JQ(f).is(':checked')) {
                r = false;
                BC.debug('ALL.isVNcompleted(): Missing input: ', f, 64);
            } else if (JQ(f).length && !JQ(f).val()) {
                r = false;
                BC.debug('ALL.isVNcompleted(): Missing input: ', f, 64);
            }
            if (!r) break;
        }
        return r;
    },

    deleteOffer: function (id) {
        if (!confirm('Wollen Sie das Angebot wirklich löschen?')) {
            return;
        }

        JQ.post(JSONURI, JSON.stringify({
            action: 'delete_offer',
            oid: id,
            csrf: JQ('body').data('csrf')
        }));

        JQ('#tr_an_' + id).remove();
    },

    loadOffer: function (_onr) {
        // Lade Angebotsdaten, falls Angebotsnummer da_onr gesetzt ist
        var onr = _onr || JQ('#f_da_onr').val();
        var a;
        if (JQ(this).hasClass('edit_offer')) {
            a = BC.get_id(this).split('_');
            onr = a[a.length - 1];
        }
        BC.debug('ALL.loadOffer(): Loading Offer ', [onr, this], 64);
        if (!onr) return;
        UNFA.vps = {};
        JQ.getJSON(JSONURI,
            {
                action: 'loadOffer',
                oid: onr,
                sid: JQ('#f_sid').val()
            },
            function (data) {
                if (data.branch === 'fhrd') {
                    PRIV.branch = 'fhrd'
                    PRIV.transformMultipleOffersJson(data)
                } else {
                    ALL.fillFormWithData(data);
                }
            });
            ALL.notifyHeight();
    },

     loadQueryParam: function () {
        var url = window.location.href;
        var startOfQuery = url.indexOf('?') + 1;
        var queryString = url.substring(startOfQuery);
        var queries = queryString.split('&');
        /** @var {object} kv */
        var queryParam = {};
        queries.forEach(function (query) {
            var arr = query.split('=');
            queryParam[arr[0]] = arr[1];
        })
        return queryParam;
    },

    move2input: function (selector, boxId) {
        var d_n = 0;
        var i;
        var t = JQ(this).attr('data-href') || JQ(this).attr('data-move2') || selector;
        if (t) {
            BC.debug('ALL.move2input(): Want to move to ', t, 64);
            if (boxId) {
                i = boxId;
            } else {
                i = ALL.get_box_id(t);
                BC.debug('ALL.move2input(): Want to move to ', i, 64);
            }
            d_n = parseInt(BC.get_id(i).split('_')[1]);
            JQ(i).removeClass('hidden').show();
            if (selector) {
                JQ('#div_98').addClass('hidden').hide();
            } else {
                BC.debug('ALL.move2input() - setting focus to', t, 64);
            }
            if (ALL.branch === "thv") {
                JQ("#div_5").addClass("hidden");
            }
            ALL.chgStateBar(d_n);
            JQ(t).focus();
            PRIV.an_read = false;
        }
        ALL.notifyHeight();
    },

    createQueryStringForMultipleBikes: function (arrayToQueryString) {
        var transformedArray = PRIV.transformOffer(arrayToQueryString);
        var esc = encodeURIComponent;
        var queryString = '';

        transformedArray.forEach(function (field) {
            queryString = esc(field['name']) + '=' + esc(field['value']) + '&' + queryString;
        });

        return queryString;
    },

    fillFakeInputsWithRealValues: function () {

        JQ("#fake-bike :input:disabled").removeAttr('disabled');

        var inputData = JQ('#frm_fhrd').serializeArray().filter(function (inputData) {
            return inputData.name.indexOf('-') !== -1
        });

        var keys = ['fhrd_plz', 'fhrd_vs', 'fhrd_ftype', 'fhrd_mtrl', 'fhrd_kauf', 'fhrd_yprd', 'fhrd_producer', 'fhrd_model', 'fhrd_frame'];

        keys.forEach(function (key) {

            var values = [];

            inputData.forEach(function (data) {
                if (data.name.indexOf(key) === 0 && data.value.length !== 0) {
                    values.push(data.value);
                }
                if (data.name.indexOf(key) === 0 && data.value.length === 0) {
                    if (['fhrd_producer', 'fhrd_model', 'fhrd_frame'].includes(key)) {
                        values.push("Bitte ergänzen");
                    } else {
                        values.push("");
                    }
                }
            })

            JQ('[name="' + key + '"]').val(values.join(','));
        })
        ALL.notifyHeight();
    },

    post_all: function () {
        var q;
        if (ALL.branch.slice(0, 4) == 'unfa' && ALL.mobile) {
            q = UNFA.make_post_data();
        } else {
            q = JQ('#frm_' + ALL.branch).serialize();
        }
        var i = JQ(this).prop('id');
        BC.debug('ALL.post_all() with branch ' + ALL.branch, [q, this], 64);
        //ALL.pdfwin = window.open('', '_priv');
        if (i == 'a_da_offer') {
            PRIV.an_read = true;
            ALL.fillFakeInputsWithRealValues()
            JQ('#frm_fhrd').serializeArray().forEach(function (field) {
                if (field.name.indexOf('-') !== -1) {
                    JQ('[name="' + field.name + '"]').attr('disabled', 'disabled');
                }
            });
            JQ('#frm_' + ALL.branch).submit();
            setTimeout(function () {
                JQ("#fake-bike :input").attr('disabled', 'disabled');
            }, 500)
            JQ("#frm_fhrd :input:disabled").removeAttr('disabled');
            ALL.chkDivReady(i, true);
            ALL.chgMobButtons(ALL.branch);
            return;
        } else if (i == 'btn_final') {
            // Doppel-POSTs verhindern:
            if (PRODSYS) JQ('#btn_final').removeClass('button_enabled').off('click');
            i = false;
        }

        if (ALL.branch === 'fhrd') {
            JQ.post('/tr/da', ALL.createQueryStringForMultipleBikes(JQ('#frm_' + ALL.branch).serializeArray()), ALL.showOk);
            return;
        }

        BC.debug('ALL.post_all(): DA is triggered!', '', 64);
        JQ.post('/tr/da',
            q,
            ALL.showOk)
    },

    set_aCode: function (data) {
        // Callback für chk_aCode
        BC.debug('ALL.set_aCode(): data =>', data, 64);
        if (ALL.acode && !data.rbt) {
            ALL.acode = false;
            PRIV[PRIV.branch].recalc();
        } else if (data.rbt) {
            ALL.acode = true;
            PRIV[PRIV.branch].recalc();
        }
    },

    setAdr: function () {
        // Setze alle anderen Anschriftenfelder,
        // unterhalb VN-Reiter nur, wenn noch nicht gefüllt:
        BC.debug('ALL.setAdr()', ALL.branch, 64);
        if (ALL.branch == 'bawe' || ALL.branch == 'phvo' || ALL.branch == 'vn' || ALL.adr.vn) return;
        JQ.each(ALL.branches, function (i, v) {
            ALL.setZuersInfo(v);
            BC.debug('ALL.setAdr(): Check PLZ for ' + v, '', 64);
            if (v == ALL.branch || !JQ('#f_' + v + '_plz').length || v == 'bawe' || v == 'phvo') return true;
            BC.debug('ALL.setAdr(): Setting PLZ etc. for ' + v, '', 64);
            JQ('#f_' + v + '_plz').val(ALL.adr.plz);
            JQ('#f_' + v + '_ort').val(ALL.adr.ort);
            JQ('#f_' + v + '_str').val(ALL.adr.snr);
            JQ('#f_' + v + '_hnr').val(ALL.adr.hnr);
        });
        ALL.set.ZUERS = true;
        BC.debug('ALL.setAdr(): ALL.set =>', ALL.set, 64);
        if (ALL.data && ALL.data.branch && ALL.chkSET()) {
            ALL.chkDate(ALL.data);
            JQ("#div_" + ALL.data.branch + "_vers").change();
        }
        if (ALL.mobile || ALL.direct) {
            JQ('#btn_set_plz_ort').hide();
            ALL.setVNadr();
        } else {
            JQ('#btn_set_plz_ort').show();
        }

        ALL.notifyHeight();
    },

    set_an_link: function (data) {
        // Erzeuge Link für neues Angebots-PDF
        var an_link = '#';
        if (!data || !data.onr) {
            JQ('#f_da_onr').val('');
            JQ('#f_da_set').val(0);
            JQ('#f_branch').val('');
            return;
        }
        JQ('#f_branch').val(PRIV.branch);
        an_link = '/TR/getdoc?' + PRIV.make_gs().join('&') + '&da_onr=' + data.onr;
        BC.debug('ALL.set_an_link() => length of an_link:', an_link.length, 64);
        return an_link;
    },

    setChkFlds: function (branch) {
        // Belege Felder in "Angaben überprüfen"
        // Aufruf teilweise in ALL.set_HNR
        var anrede = 'Herr';
        BC.debug('ALL.setchkFlds(' + branch + ')', '', 64);
        JQ('#m098_zw').text(zws[JQ('#f_' + branch + '_zw').val()][0]);
        JQ('#m098_start').text(JQ('#f_' + branch + '_start').val());
        JQ('#m098_ende').text(JQ('#f_' + branch + '_ende').val());
        if (JQ('#f_vn_anrede').val() == '2') anrede = 'Frau';
        else if (JQ('#f_vn_anrede').val() == '5') anrede = 'Divers';
        else if (JQ('#f_vn_anrede').val() == '4') anrede = 'Firma';
        JQ('#m098_vn').text(anrede + ' ' +
            JQ('#f_vn_vorname').val() + ' ' +
            JQ('#f_vn_nachname').val());
        JQ('#m098_adr').text(ALL.adr.vn_plz + ' ' + ALL.adr.vn_ort + ', ' +
            ALL.adr.vn_str + ' ' + ALL.adr.vn_hnr);
        JQ('#m098_gebdat').text(JQ('#f_vn_gebdat').val());
        JQ('#m098_email').text(JQ('#f_vn_email').val());
        JQ('#m098_mobnr').text(JQ('#f_vn_mobnr').val());
        if (JQ('#f_da_vv1_1').is(':checked')) {
            JQ('#m098_vv3').text(JQ('#f_da_vv3').val());
            JQ('#m098_vv4').text(JQ('#f_da_vv4').val());
            JQ('#m098_vv5').text(JQ('#f_da_vv5').val());
            JQ('#p098_vv5').text('ABLAUFDATUM VORVERSICHERUNG');
        } else {
            JQ('#m098_vv3').text('nicht vorhanden');
            JQ('#m098_vv4').text('---------');
            JQ('#m098_vv5').text(JQ('#f_da_vv1a').val());
            JQ('#p098_vv5').text('GRUND FÜR FEHLENDE VORVERSICHERUNG');
        }
        JQ('#m098_vv6').text(JQ('#f_da_vv6').val());
        if (parseInt(JQ('#f_da_vv6').val())) {
            JQ('#div098_vv6a').show();
            JQ('#m098_vv6a').text(JQ('#f_da_vv6a').val());
        } else {
            JQ('#div098_vv6a').hide();
            JQ('#m098_vv6a').text('nicht zutreffend');
        }
        if (JQ('#f_da_za_2').is(':checked')) {
            JQ('#m098_zatext').text('Rechnung');
            JQ('#m098_iban').text('');
            JQ('#div098_iban').hide();
        } else {
            JQ('#m098_zatext').text('Lastschrift');
            JQ('#m098_iban').text(JQ('#f_da_iban').val());
            JQ('#div098_iban').show();
        }
        if (JQ('#f_da_rem').val()) {
            JQ('#span_last_da_rem').text(JQ('#f_da_rem').val());
        } else {
            JQ('#span_last_da_rem').text('------');
        }
        ALL.notifyHeight();
    },

    setContactData: function (data) {
        BC.debug('ALL.setContactData(): ', data);
        ALL.chkError(data);
        JQ('#f_email1').val(data.email1);
        JQ('#f_sach_dira_email').val(data.email1);
        JQ('#f_haft_dira_email').val(data.email1);
        JQ('#f_sach_dira_tel').val(data.tel);
        JQ('#f_haft_dira_tel').val(data.tel);

        ALL.notifyHeight();
    },

    setFlds: function (data) {
        BC.debug('ALL.setFlds(data) - data:', data, 64);
        ALL.FldsAll = data;
    },

    setFldsEnOrDisabled: function (e) {
        //BC.debug(this.name, this.id, this, JQ(this).is(':checked'));
        BC.debug('ALL.setFldsEnOrDisabled(): ');
        ALL.getFldsSet();
        var conflicts = (ALL.FldsAll[e.target.name] && ALL.FldsAll[e.target.name]['conflicts']) ? ALL.FldsAll[e.target.name]['conflicts'] : [];
        JQ.each(ALL.FldsAll, function (k0, v0) {
            var l0 = ALL.FldsAll[k0]['requires'] ? ALL.FldsAll[k0]['requires'] : [];
            l0.sort();
            var l1 = [];
            JQ.each(ALL.FldsSet, function (k1, v1) {
                if (JQ.inArray(k1, l0) >= 0 && v1) l1.push(k1);
            });
            l1.sort();
            if (l0.join() == l1.join()) {
                // Abhängiges Feld kann enabled werden, alle
                // dafür notwendigen Felder sind enabled
                ALL.endisabled[k0] = true;
            } else {
                ALL.endisabled[k0] = false;
            }
        });
        // Nun noch die Felder disablen, bei denen ein Konflikt ausgeloest wird:
        //BC.debug('ALL.setFldsEnOrDisabled() CONFLICTS: ', conflicts);
        JQ.each(conflicts, function (k0, v0) {
            JQ.each(ALL.FldsAll, function (k1, v1) {
                if (JQ.inArray(v0, v1['requires']) >= 0) {
                    ALL.endisabled[k1] = false;
                }
            });
        });
        //BC.debug('ALL.setFldsEnOrDisabled() ENDISABLED: ', ALL.endisabled);
        JQ.each(ALL.endisabled, function (k, v) {
            id = '#f_' + k;
            /*if (! v) {
              JQ(id).val(0);
              }*/
            if (JQ(id).is(':checkbox') && !v) {
                JQ(id).attr({checked: false, disabled: true});
                JQ(id).hide();
                JQ('#l_' + k).hide();
                //} else if JQ(id).is(':checkbox')) {
            } else if (v && JQ.inArray(k, conflicts) >= 0) {
                JQ(id).attr({checked: false});
            } else if (v) {
                JQ(id).show();
                JQ('#l_' + k).show();
                JQ(id).attr({disabled: false});
            }
        });

        ALL.notifyHeight();
    },

    setHNR: function (data) {
        BC.debug('ALL.setHNR(): branch, data => ', [ALL.branch, ALL.adr, data], 64);
        if (data && ALL.adr.vn) {
            ALL.adr.vn_plz = data.pl_plz;
            ALL.adr.vn_ort = data.or_ort;
            ALL.adr.vn_snr = data.st_id;
            ALL.adr.vn_str = data.st_strasse;
            ALL.adr.vn_hnr = data.nr_nr;
        } else if(data && (ALL.adr.phvo || ALL.branch == 'phvo')) {
            ALL.adr.phvo_plz = data.pl_plz;
            ALL.adr.phvo_ort = data.or_ort;
            ALL.adr.phvo_snr = data.st_id;
            ALL.adr.phvo_str = data.st_strasse;
            ALL.adr.phvo_hnr = data.nr_nr;
        } else if (data && data.nr_gk) {
            ALL.adr.plz = data.pl_plz;
            ALL.adr.ort = data.or_ort;
            ALL.adr.snr = data.st_id;
            ALL.adr.str = data.st_strasse;
            ALL.adr.hnr = data.nr_nr;
            ALL.adr.zz = data.nr_gk;
            ALL.adr.bach = data.nr_bach;
            try {
                if (PRIV[ALL.branch] && PRIV[ALL.branch].setChkFlds)
                    PRIV[ALL.branch].setChkFlds();
            } catch (e) {
                BC.debug('ALL.setHNR(): Could not call setChkFlds()!', e, 16);
            }
        } else {
            ALL.adr.zz = 0;
        }
        ALL.set.HNR = true;
        ALL.setAdr();
        ALL.notifyHeight();
    },

    setHNRs: function (data) {
        BC.debug('ALL.setHNRs():', data, 64);
        if (!data || !data.nl) return;
        if (ALL.branch == 'vn' || ALL.adr.vn) {
            // Sonderfall, hier dürfen nicht Risikoadressen überschrieben werden!
            BC.debug('ALL.setHNRs() - Setting PLZ, Ort, Str and Hnr only for VN', '', 64);
            ALL.fillOlist('vn', 'nl', data);
            //ALL.adr.vn_snr = JQ('#f_vn_str').val();
            //ALL.adr.vn_str = JQ('#f_vn_str option:selected').text();
            if (data.nl && data.nl.length) ALL.adr.vn_hnr = data.nl[0].nr_nr;
            //JQ('#f_vn_hnr').empty().append(ALL.adr.vn_hlist).attr("readonly", false).prop('disabled', false);
            return;
        } else if (ALL.branch == 'phvo') {
            // Sonderfall, hier dürfen nicht Risikoadressen überschrieben werden!
            BC.debug('ALL.setHNRs() - Setting PLZ, Ort, Str and Hnr only for PHVO', '', 64);
            ALL.fillOlist('phvo', 'nl', data);
            if (data.nl && data.nl.length) ALL.adr.phvo_hnr = data.nl[0].nr_nr;
            return;
        } else {
            BC.debug('ALL.setHNRs(branch=' + ALL.branch + ') branches =>', ALL.branches, 64);
            ALL.fillOlist('obj', 'nl', data);
        }
    },

    setORT: function (data) {
        var _str;
        BC.debug('ALL.setORT():', data, 64);
        if (data && data.sl && data.sl.length) {
            if (ALL.branch != 'bawe') ALL.adr.plz = JQ('#f_' + ALL.branch + '_plz').val();
            ALL.setPLZs(data);
        }
        if (ALL.data && ALL.data.branch) {
            _str = ALL.data.branch + '_str';
            JQ('#f_' + _str).val(ALL.data[_str]).change();
            BC.debug('ALL.setORT(): ORT set, S-list loaded | ALL.set =>', ALL.set, 64);
        } else if (!ALL.adr.vn) {
            JQ("#f_" + ALL.branch + "_hnr").change();
        }
        // Wenn ALL.set.ORT == true, dann ist die Straßenliste geladen,
        // aber noch kein bzw. der erste Wert aus der Liste ausgewählt.
        ALL.set.ORT = true;
        ALL.notifyHeight();
    },

    setPLZ: function (data) {
        var _ort;
        BC.debug('ALL.setPLZ() for ' + ALL.branch, data, 64);
        if (data.ol.length) {

            if (ALL.branch == 'phvo') {
                ALL.adr.phvo_plz = JQ('#f_' + ALL.branch + '_plz').val();
            } else if (ALL.adr.vn) {
                ALL.adr.vn_plz = JQ('#f_vn_plz').val();
                BC.debug('ALL.setPLZ() for VN only', ALL.adr, 64);
            } else if (ALL.branch != 'bawe' && JQ('#f_' + ALL.branch + '_plz').length) {
                ALL.adr.plz = JQ('#f_' + ALL.branch + '_plz').val();
            } else if (ALL.branch == 'phth') {
                BC.debug('ALL.setPLZ(): Unknown branch!', this, 64);
                ALL.adr.plz = JQ('#f_phth-gh_plz').val() || JQ('#f_phth-hh_plz').val();
            }
            ALL.setPLZs(data);
        }
        BC.debug('ALL.setPLZ() for ' + ALL.branch, ALL.data, 64);
        //if (data && data.ol && data.ol.length > 1) {
        //    _ort = ALL.branch + '_ort';
        //    JQ('#f_' + _ort).val(data.ol[0]).change();
        //    BC.debug('ALL.setPLZ(): PLZ set, O-list loaded | ALL.set =>' , ALL.set, 64);

        if (ALL.data && ALL.data.branch) {
            _ort = ALL.data.branch + '_ort';
            JQ('#f_' + _ort).val(ALL.data[_ort]).change();
            BC.debug('ALL.setPLZ(): PLZ set, O-list loaded | ALL.set =>', ALL.set, 64);
        } else if (!ALL.adr.vn) {
            JQ("#f_" + ALL.branch + "_hnr").change();
        }
        ALL.notifyHeight();
    },

    setPLZs: function (data) {
        if (!data) return;
        if (data.ol && (ALL.branch == 'vn' || ALL.adr.vn)) {
            // Sonderfall, hier dürfen nicht Risikoadressen überschrieben werden!
            BC.debug('ALL.setPLZs() - Setting PLZ, Ort, Str and Hnr only for VN', '', 64);
            ALL.fillOlist('vn', 'ol', data);
            //if (data.ol && data.ol.length) ALL.adr.vn_ort = data.ol[0].or_ort;
            ALL.adr.vn = true;
        } else if (data.ol && (ALL.branch == 'phvo' || ALL.adr.phvo)) {
            // Sonderfall, hier dürfen nicht Risikoadressen überschrieben werden!
            BC.debug('ALL.setPLZs() - Setting PLZ, Ort, Str and Hnr only for PHVO', '', 64);
            ALL.fillOlist('phvo', 'ol', data);
            //if (data.ol && data.ol.length) ALL.adr.vn_ort = data.ol[0].or_ort;
            ALL.adr.phvo = true;
        } else if (data.ol) {
            BC.debug('ALL.setPLZs(branch=' + ALL.branch + ') branches =>', [ALL.branches, data], 64);
            ALL.fillOlist('obj', 'ol', data);
        }
        if (data.nl && data.nl.length != 0) {
            ALL.setSTRs(data);
            ALL.setHNRs(data);
        }
        if (ALL.adr.vn) ALL.haveVN();
        // Wenn ALL.set.PLZ == true, dann ist die Ortsliste gefüllt
        ALL.set.PLZ = true;
        ALL.notifyHeight();
    },

    setSTR: function (data) {
        var _hnr;
        BC.debug('ALL.setSTR():', data, 64);
        ALL.setHNRs(data);
        if (ALL.data && ALL.data.branch) {
            _hnr = ALL.data.branch + '_hnr';
            JQ('#f_' + _hnr).val(ALL.data[_hnr]).change();
            BC.debug('ALL.setSTR(): STR set, H-list loaded | ALL.set =>', ALL.set, 64);
        } else if (!ALL.adr.vn) {
            BC.debug('ALL.setSTR(): Triggering change of #f_' + ALL.branch + '_hnr', '', 64);
            JQ("#f_" + ALL.branch + "_hnr").change();
        }
        // Wenn ALL.set.STR == true, dann ist die Hausnummernliste gefüllt
        ALL.set.STR = true;
        ALL.notifyHeight();
    },

    setSTRs: function (data) {
        if (!data) return;
        if (data.sl && (ALL.branch == 'vn' || ALL.adr.vn)) {
            // Sonderfall, hier dürfen nicht Risikoadressen überschrieben werden!
            ALL.fillOlist('vn', 'sl', data);
            if (data.sl && data.sl.length) {
                ALL.adr.vn_snr = data.sl[0].st_id;
                ALL.adr.vn_str = data.sl[0].st_strasse;
            }
        } else if (data.sl && (ALL.branch == 'phvo' || ALL.adr.phvo)) {
            // Sonderfall, hier dürfen nicht Risikoadressen überschrieben werden!
            ALL.fillOlist('phvo', 'sl', data);
            if (data.sl && data.sl.length) {
                ALL.adr.phvo_snr = data.sl[0].st_id;
                ALL.adr.phvo_str = data.sl[0].st_strasse;
            }
        } else if (data.sl) {
            BC.debug('ALL.setSTRs(branch=' + ALL.branch + ') branches =>', ALL.branches, 64);
            ALL.fillOlist('obj', 'sl', data);
        }

        ALL.notifyHeight();
    },

    setVNadr: function () {
        // Befülle alle Adress-Felder unterhalb "Daten VN"
        BC.debug('ALL.setVNadr() called with ALL.adr.plz=', ALL.adr.plz, 64);
        if (ALL.adr.phvo_ort && ! ALL.adr.ort) {
            ALL.adr.vn_plz = ALL.adr.plz;
            ALL.adr.vn_ort = ALL.adr.phvo_ort;
            ALL.adr.vn_snr = ALL.adr.phvo_snr;
            ALL.adr.vn_str = ALL.adr.phvo_str;
            ALL.adr.vn_hnr = ALL.adr.phvo_hnr;
            ALL.adr.vn_olist = ALL.adr.phvo_olist;
            ALL.adr.vn_slist = ALL.adr.phvo_slist;
            ALL.adr.vn_hlist = ALL.adr.phvo_hlist;
            JQ('#f_vn_plz').val(ALL.adr.vn_plz);
            JQ('#f_vn_ort').empty().append(ALL.adr.vn_olist).attr("readonly", false).prop('disabled', false).val(ALL.adr.vn_ort);
            JQ('#f_vn_str').empty().append(ALL.adr.vn_slist).attr("readonly", false).prop('disabled', false).val(ALL.adr.vn_snr);
            JQ('#f_vn_hnr').empty().append(ALL.adr.vn_hlist).attr("readonly", false).prop('disabled', false).val(ALL.adr.vn_hnr);
            ALL.haveVN();
        } else if (ALL.adr.plz) {
            ALL.adr.vn_plz = ALL.adr.plz;
            ALL.adr.vn_ort = ALL.adr.ort;
            ALL.adr.vn_snr = ALL.adr.snr;
            ALL.adr.vn_str = ALL.adr.str;
            ALL.adr.vn_hnr = ALL.adr.hnr;
            ALL.adr.vn_olist = ALL.adr.olist;
            ALL.adr.vn_slist = ALL.adr.slist;
            ALL.adr.vn_hlist = ALL.adr.hlist;
            JQ('#f_vn_plz').val(ALL.adr.vn_plz);
            JQ('#f_vn_ort').empty().append(ALL.adr.vn_olist).attr("readonly", false).prop('disabled', false).val(ALL.adr.vn_ort);
            JQ('#f_vn_str').empty().append(ALL.adr.vn_slist).attr("readonly", false).prop('disabled', false).val(ALL.adr.vn_snr);
            JQ('#f_vn_hnr').empty().append(ALL.adr.vn_hlist).attr("readonly", false).prop('disabled', false).val(ALL.adr.vn_hnr);
            ALL.haveVN();
        }
        ALL.notifyHeight();
    },

    setZuersInfo: function (branch) {
        // Setze ZuersZone und disable ggf. Auswahlbutton
        // fuer Elementarschaden-Mitversicherung
        BC.debug('ALL.setZuersInfo(): branch=', branch, 256);
        if (!JQ('#s_zuersz_' + branch).length) return;
        if (!ALL.adr.zz) {
            JQ('#s_zuersz_' + branch).text('??');
        } else {
            JQ('#s_zuersz_' + branch).text('' + ALL.adr.zz + ALL.adr.bach);
        }
        var zz = (ALL.adr.zz > 2 || !ALL.adr.zz);
        JQ('#f_' + branch + '_el_0').prop('disabled', zz);
        JQ('#f_' + branch + '_el_1').prop('disabled', zz);
        if (zz) {
            JQ('#f_' + branch + '_el_0').attr('checked', true);
            JQ('#f_' + branch + '_el_1').attr('checked', false);
        }
        ALL.notifyHeight();
    },

    setZWs: function (data) {
        if (!data || !data.zws || !data.branch) return;
        BC.debug('ALL.setZWs(branch=' + data.branch + ')', data.zws, 64);
        if (!ALL.data) ALL.data = data;
        ALL.data.zws = data.zws;
        var zw_str;
        var branch = data.branch + (data.branch == 'hara' && data.subbranch == 'sk' ? '1' : '');
        var zw_fld = '#f_' + branch + '_zw'; // Name des ZW-select-Feldes
        if (!JQ(zw_fld).length) zw_fld = '#f_' + data.branch + '-' + data.subbranch + '_zw';
        if (!JQ(zw_fld).length) zw_fld = '#f_' + data.branch + '-' + data.ptype + '_zw';
        var zw = JQ(zw_fld).val();
        var zw_options = [];
        JQ.each(data.zws, function (i, v) {
            // Fülle die ZW-Liste
            zw_str = '<option value="' + v + '"';
            if (v == zw) zw_str += ' selected=""';
            if (ALL.mobile) {
                zw_str += '>' + zws[v][0] + '</option>';
            } else {
                zw_str += '>' + zws[v][1] + '</option>';
            }
            zw_options.push(zw_str);
        });
        BC.debug('ALL.setZWs(zw_fld=' + zw_fld + ')', zw_options, 512);
        JQ(zw_fld).empty().append(zw_options.join(''));
        ALL.notifyHeight();
    },

    showAN: function (data) {
        // Zeige Angebots-PDF in neuem Fenster
        BC.debug('ALL.showAN() called', data, 64);
        if (!data || !data.uri) {
            return;
        }
        ALL.pdfwin.location = data.uri;
    },

    showANs: function (data, adminForm) {
        // Callback-Funktion für ALL.loadANs
        // M.E. ist in tablesorter ab- und aufsteigend vertauscht, deshalb
        // im tablesorter-Aufruf das erneute Vertauschen von Down und Up!
        BC.debug('ALL.showANs() called!', '', 64);
        JQ('#div_AN').html(data.html);
        JQ('.delete_offer').click(function () {
            var offerId = JQ(this).attr('id');
            ALL.deleteOffer(offerId);
        });
        JQ('.edit_offer').click(ALL.loadOffer);
        JQ('#table_vm_ans').tablesorter({
            headers: {
                0: {sorter: 'DEdatetime'},
                3: {sorter: false},
                4: {sorter: false}
            },
            widgets: ['zebra'],
            cssAsc: 'headerSortDown',
            cssDesc: 'headerSortUp'
        });
        // disable edit / delete offers
        if (adminForm === 'admin') {
            if (ADM0.vmid !== ADM0.currentUser) {
                JQ('.edit_offer').each(function (i, el) {
                    JQ(el).hide()
                })
                JQ('.delete_offer').each(function (i, el) {
                    JQ(el).hide()
                })
            }
            ;
        }
    },

    showButton: function (p, v) {
        // p = Produkt, v = bool
        BC.debug('ALL.showButton(' + p + ', ' + v + '): called', '', 256);
        PRIV.branch = p;
        if (!v) {
            JQ('#spn_' + p + '_an_btn').hide();
            JQ('#spn_' + p + '_da_btn').hide();
            return;
        }
        JQ('#spn_' + p + '_an_btn').show();
        JQ('#spn_' + p + '_da_btn').show();
    },

    showDAs: function (data) {
        // Callback-Funktion für ALL.loadDAs
        // M.E. ist in tablesorter ab- und aufsteigend vertauscht, deshalb
        // im tablesorter-Aufruf das erneute Vertauschen von Down und Up!
        BC.debug('ALL.showDAs() called!', '', 64);
        JQ('#div_DA').html(data.html);
        JQ('#table_vm_das').tablesorter({
            headers: {
                0: {sorter: 'DEdatetime'},
                4: {sorter: false}
            },
            widgets: ['zebra'],
            cssAsc: 'headerSortDown',
            cssDesc: 'headerSortUp'
        });
    },

    showHelp: function () {
        // Falls das Element ein Attribut "data-help" besitzt,
        // wird das Attribut mittels showInfo angezeigt
        var t = JQ(this).attr('data-help');
        if (t == undefined || !t) return;
        ALL.showInfo(t, 'HINWEIS');
    },

    showHint: function (t, h, f) {
        // Öffne Hinweisfenster und zeige Text t an.
        // Dazu muss im jeweiligen Formular ein div mit der
        // nachstehenden ID "div_hint_generic" vorhanden sein.
        if (!t) return;
        if (f == undefined) f = true;
        //ALL.hints = JQ('#div_hint_generic').html() + '<br/>' + t
        if (ALL.hints.indexOf(t) >= 0 && !f) return;
        ALL.hints.push(t);
        if (ALL.mobile) {
            BC.debug('ALL.showHint for mobile would show:', t, 64);
            ALL.showInfo(t, (h ? 'FEHLER' : 'HINWEIS'));
            return;
        }
        JQ('#div_hint_generic').html(t);
        JQ('#div_hint_generic').dialog({title: h ? "FEHLER:" : "HINWEIS:"});
        JQ('#div_hint_generic').dialog('open');
    },

    showInfo: function (t, h, err) {
        // function called by (i)-Buttons resp. div in which button is placed
        // div has i.e. id "ibtn_hara2_ded"
        // so hara2 is the branch => HARA2
        // and ded is the entry which must exist in namespace HARA2.info
        // HARA.info.ded.head is the text for #head_info
        // HARA.info.ded.html is the html for #text_info
        var w = ALL.get_w_sizes();
        var top = w.win_t + w.win_h / 2;
        var info;
        if (h === undefined) h = '';
        if (err === undefined) err = false;
        BC.debug('ALL.showInfo for mobile would show: ', [t, h, this, ALL.classof(t)], 64);
        if (JQ(this).attr('data-infoHtml')) {
            JQ('#head_info').html(JQ(this).attr('data-infoHead'));
            JQ('#text_info').html(JQ(this).attr('data-infoHtml'));
        } else if (!t || ALL.classof(t) == 'Object') {
            var b = BC.get_id(this).split('_');
            BC.debug('ALL.showInfo for mobile would show:', [t, b, this], 256);
            try {
                if (this.dataset.infohead) {
                    info = {
                        'head': this.dataset.infohead,
                        'html': this.dataset.infohtml
                    };
                } else {
                    info = PRIV[b[1]]['info'][b[2]];
                }
                if (!info) return;
            } catch (e) {
                BC.debug('ALL.showInfo() failed!', e, 16);
                return;
            }
            JQ('#head_info').text(info['head']);
            JQ('#text_info').html(info['html']);
        } else {
            JQ('#head_info').text(h);
            JQ('#text_info').html(t);
        }
        if (h.toUpperCase() == 'FEHLER' || err) {
            JQ('#head_info').css({'color': '#FFFFFF'})
            JQ('#overlay').removeClass('ovl-info').addClass('ovl-error').show();
            JQ('#div_info').removeClass('info').addClass('error');
            JQ('#div_close_99').addClass('button_error');
            JQ('#svg_close_btn').css({'fill': '#FFFFFF'});
            JQ('#pth_cb_99').css({'stroke': '#F7A707', 'fill': '#F7A707'});
        } else {
            JQ('#head_info').css({'color': '#000'})
            JQ('#overlay').removeClass('ovl-error').addClass('ovl-info').show();
            JQ('#div_info').removeClass('error').addClass('info');
            JQ('#div_close_99').removeClass('button_error');
            JQ('#svg_close_btn').css({'fill': '#CC0000'});
            JQ('#pth_cb_99').css({'stroke': '#FFFFFF', 'fill': '#FFFFFF'});
        }
        top = top - JQ('#div_info').height() / 2;
        //JQ('#div_info').show().css({'top': top, 'display': 'grid'});
        JQ('#div_info').show().css({'display': 'grid', 'margin': 0}).center();
        ALL.notifyHeight();
    },

    showOk: function (data) {
        BC.debug('ALL.showOk called...', data, 64);

        if (data.error || data.success === false) {
            BC.debug('ALL.post_all(): DA failed!', '', 64);
            JQ('#btn_bck_98').trigger('click');

            // send back to step 5
            PRIV.an_read = false;
            JQ('#btn_fwd_5').removeClass('button_enabled');
            JQ('#btn_final').addClass('button_enabled').click(ALL.post_all);
            JQ('#f_da3_1').attr('checked', false)

            ALL.showHint('Fehler beim Erstellen des Deckungsauftrages. Bitte versuchen Sie zunächst das Angebot und dann erneut den Deckungsauftrag zu generieren.');
            ALL.notifyHeight();
            return;
        }

        ALL.chgDiv();
        ALL.notifyHeight();
    },

    timeOut: function () {
        // Adapted from http://stackoverflow.com/questions/667555/detecting-idle-time-in-javascript-elegantly
        if (JQ('#f_direct').length) return;
        // Increment the idle time counter every minute.
        var idleInterval = setInterval(ALL.timerIncrement, 5000); // 5 seconds

        //Zero the idle timer on mouse movement.
        JQ('body').mousemove(function (e) {
            //BC.debug("mouse moved" + idleTime);
            idleTime = 0;
        });

        JQ('body').keypress(function (e) {
            //BC.debug("key pressed"  + idleTime);
            idleTime = 0;
        });

        JQ('body').click(function () {
            //BC.debug("mouse clicked" + idleTime);
            idleTime = 0;
        });

    },

    timerIncrement: function () {
        idleTime = idleTime + 5;
        //BC.debug('timerIncrement: ' + idleTime);
        if (idleTime > maxIdle) {
            window.location.replace('/TR/logout');
        }
    },

    /**
     * @param {String} type The insurance type e.g. "Unfall" or "Fahrrad"
     * @param {String} branch the branch that was calculated e.g. "hara2" or "thv"
     */
    triggerDataLayerEvent: function (type, branch) {
        BC.debug('ALL.triggerDataLayerEvent("' + type + '", "' + branch + '") called!', '', 64);

        var totalField = JQ("#f_" + branch + "_brt2");
        var totalPerPaymentField = JQ("#f_" + branch + "_brt1");
        var paymentsField = JQ("#f_" + branch + "_zw");
        var dataLayer = window.dataLayer || [];
        var event = {
            "event": "Versicherungsantrag erstellt",
            "type": type,
            "total": totalField.text(),
            "totalPerPayment": totalPerPaymentField.text(),
            "payments": paymentsField.val(),
        };

        BC.debug('ALL.triggerDataLayerEvent() pushing event to dataLayer', event, 64);
        dataLayer.push(event);
    },

    updateTips: function (t) {
        tips
            .text(t)
            .addClass("ui-state-highlight");
        setTimeout(function () {
            tips.removeClass("ui-state-highlight", 1500);
        }, 500);
    },

    validDate: function (t) {
        // Prüft ob Datum t gültig ist
        return moment(t, 'DD.MM.YYYY').isValid();
    },

};

global.SESSION = {
    getId: function () {
        return JQ('#f_sid').val()
    }
}